import React, { useEffect, useState, useRef } from "react";
import { CustomButton, CustomInput } from "components";
import moment from "moment";
import { v4 as uuidv4} from "uuid"
import "./style.scss";

const InputBlog = ({
  functionData = () => {},
  onChange = () => {},
  email = '',
  resources = [],
}) => {
  const [textModal, setTextModal] = useState("");
  const [Link, setDataInputModal] = useState("");
  const [bulCaseInput,setBulCaseInput] = useState(false)
  const [rangeForLink, setRangeForLink] = useState(null);
  const [selectionOfButton,setSelectionOfButton] = useState('')
  const [idClock, setIdClock] = useState('');

  let clockCtrlZ = useRef(null);
  let clock = useRef(null);
  let clockColor = useRef(null);
  let objectMemory = useRef([]);
  let objectMemory2 = useRef([]);
  let lengthBeforeContainer = useRef(null)
  let indexPaste = useRef(null)

  let arrayReset = []
  let bulUl = false;
  let bulOl = false;
  let bulBlockquote = false;
  let bulCode = false;
  let bulA = false;
  let bulBold = false;
  // let isEdit = false;
  let bulFigcaption = false
  let filesAdd = {}
  let range;
  let seleccion;

  const esPadre = (elementoHijo, posiblePadre) => {
    try{
      return posiblePadre.contains(elementoHijo);
    }catch{
      return false
    }
  }

  useEffect(() => {
    setIdClock(uuidv4())
  }, []);

  const onChangeInformation = (containerInput,bul = false) => {
    try{
      onChange({
        data: () => elementResponse(containerInput),
        functionReplaceImage: (images) => replaceImagesResponse(images,containerInput),
        functionValueDefault: (data) => valueDefaultTransform(data,containerInput),
        reset: () => resetInput(containerInput)
      })

      clearTimeout(clockCtrlZ.current)

      if(!bul){
        const children = containerInput.children
        for (let i = 0; i < children.length; i++) {
          let reg = /@/
          const regex = /^child-position-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

          if (!reg.test(children[i].id) 
            && (children[i]?.previousElementSibling?.id === children[i]?.id || !children[i]?.id || (i === 0 && !regex.test(children[i].id) && children[i]?.previousElementSibling?.id === undefined) || !regex.test(children[i].id))
        ) {
            children[i].id = `child-position-${uuidv4()}`
          }

          const newP = document.createElement("p");
          newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
          newP.setAttribute("data-placeholder", "Write here");
        
          if (children[i].tagName === 'DIV' && children[i].className !== 'divider-container' && children[i].className !== 'container-insert' && children[i].className !== 'button-container-input' && children[i].classList.contains('hs-cta-embed') && children[i].children[0].classList.contains('hs-cta-embed')) {
            newP.innerHTML = `<br/>`
            children[i].parentElement.insertBefore(newP, children[i])
            children[i + 1].remove()
          }
          
          if (['P'].includes(children[i].tagName) && children[i].textContent !== '') {
            children[i].className = `none-before`
          }
          // if(['H2','H3','H4'].includes(children[i].tagName)) {
          //   children[i].style.cssText = "padding-top: 5px; padding-bottom: 5px; margin-top:20px !important; margin-bottom:20px !important;";
          // }
        }
        
        clockCtrlZ.current = setTimeout(() => {
          try {
            
            let index = 0
            let elementIndex = document.querySelectorAll(".container-html-editable")
            elementIndex.forEach((e,ind) => {
              if(esPadre(containerInput, e.parentElement)){
                index = ind
              }
            })

            const divReset = document.createElement("div");
            divReset.innerHTML = elementResponse(containerInput).body
            let arrayZ1 = JSON.parse(localStorage.getItem('contentZ')) ? JSON.parse(localStorage.getItem('contentZ')) : []
            let arrayZ = arrayZ1[index] ? arrayZ1[index] : []
    
            if(arrayZ.length > 300){
              arrayZ.shift();
            }
            
            if(divReset.children[0]){
              if(arrayZ[arrayZ.length-1] !== divReset.children[0].innerHTML){
                arrayZ.push(divReset.children[0].innerHTML) 
              } 
            }
    
            localStorage.setItem('contentZ',JSON.stringify({...arrayZ1,[index]:arrayZ}))
          }catch(er){
            console.log(er)
          }
        }, 200);
      }
    }catch(er){
      console.log(er)
    }
  }

  const selectSituation = () => {
    try {
      arrayReset.forEach((a) => {
        a.className = "container-button";
        bulUl = false
        bulOl = false
        bulBlockquote = false
        bulCode = false
        bulA = false
        bulBold = false
      })

      range = document?.getSelection()?.getRangeAt(0);
      seleccion = window.getSelection();
      const containerAll = document.getElementById(`father-input-blog-${idClock}`);

      if(range){
        const firstSon = (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
        const secondSon =  (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode

        const contenedor = document.createElement("div"); 
        contenedor.appendChild(range.cloneContents());

        const htmlSeleccionado = contenedor.innerHTML;

        if (esPadre(firstSon, containerAll) && esPadre(secondSon, containerAll)) {
          let case1 = (firstSon || {}).tagName;
          let case2 = ((firstSon || {}).parentElement || {}).tagName;
          let case3= (((firstSon || {}).parentElement || {}).parentElement || {}).tagName;
          let case4 = ((((firstSon || {}).parentElement || {}).parentElement || {}).parentElement || {}).tagName;
          let case5 = (((((firstSon || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).tagName;
          let case6 = ((((((firstSon || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).tagName;
          let cased1 = (firstSon || {}).tagName;
          let cased2 = ((firstSon || {}).parentElement || {}).tagName;
          let cased3= (((firstSon || {}).parentElement || {}).parentElement || {}).tagName;
          let cased4 = ((((firstSon || {}).parentElement || {}).parentElement || {}).parentElement || {}).tagName;
          let cased5 = (((((firstSon || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).tagName;
          let cased6 = ((((((firstSon || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).tagName;

          if (case1 === "B" || case2 === "B" || case3 === "B"
            || cased1 === "B" || cased2 === "B" || cased3 === "B") {
            arrayReset[0].className = "container-button-active"
            bulBold = true
          }
          if (case1 === 'I' || case2 === "I" || case3 === "I"
            || cased1 === 'I' || cased2 === "I" || cased3 === "I") {
            arrayReset[1].className = "container-button-active"
          }
          if (case1 === "A" || case2 === "A" || case3 === "A" || htmlSeleccionado.includes('</a>')
            || cased1 === "A" || cased2 === "A" || cased3 === "A" || htmlSeleccionado.includes('</a>')) {
            arrayReset[7].className = "container-button-active"
            bulA = true
          }
          if (case1 === "UL" || case2 === "UL" || case3 === "UL" || case4 === "UL" || case5 === "UL" || case6 === "UL"
            || cased1 === "UL" || cased2 === "UL" || cased3 === "UL" || cased4 === "UL" || cased5 === "UL" || cased6 === "UL") {
            arrayReset[2].className = "container-button-active"
            bulUl = true
          }
          if (case1 === "OL" || case2 === "OL" || case3 === "OL" || case4 === "OL" || case5 === "OL" || case6 === "OL"
            || cased1 === "OL" || cased2 === "OL" || cased3 === "OL" || cased4 === "OL" || cased5 === "OL" || cased6 === "OL") {
            arrayReset[3].className = "container-button-active"
            bulOl = true
          }
          if (case1 === "BLOCKQUOTE" || case2 === "BLOCKQUOTE" || case3 === "BLOCKQUOTE" || case4 === "BLOCKQUOTE" || case5 === "BLOCKQUOTE" || case6 === "BLOCKQUOTE"
            || cased1 === "BLOCKQUOTE" || cased2 === "BLOCKQUOTE" || cased3 === "BLOCKQUOTE" || cased4 === "BLOCKQUOTE" || cased5 === "BLOCKQUOTE" || cased6 === "BLOCKQUOTE") {
            arrayReset[4].className = "container-button-active"
            bulBlockquote = true
          }
          if (case1 === "PRE" || case2 === "PRE" || case3 === "PRE" || case4 === "PRE" || case5 === "PRE" || case6 === "PRE"
            || cased1 === "PRE" || cased2 === "PRE" || cased3 === "PRE" || cased4 === "PRE" || cased5 === "PRE" || cased6 === "PRE") {
            arrayReset[5].className = "container-button-active"
            bulCode = true
          }
          if (case1 === "H2" || case2 === "H2" || case3 === "H2" || case4 === "H2" || case5 === "H2" || case6 === "H2"
            || cased1 === "H2" || cased2 === "H2" || cased3 === "H2" || cased4 === "H2" || cased5 === "H2" || cased6 === "H2") {
            arrayReset[11].value = "h2"
          }
          if (case1 === "H3" || case2 === "H3" || case3 === "H3" || case4 === "H3" || case5 === "H3" || case6 === "H3"
            || cased1 === "H3" || cased2 === "H3" || cased3 === "H3" || cased4 === "H3" || cased5 === "H3" || cased6 === "H3") {
            arrayReset[11].value = "h3"
          }
          if (case1 === "H4" || case2 === "H4" || case3 === "H4" || case4 === "H4" || case5 === "H4" || case6 === "H4"
            || cased1 === "H4" || cased2 === "H4" || cased3 === "H4" || cased4 === "H4" || cased5 === "H4" || cased6 === "H4") {
            arrayReset[11].value = "h4"
          }
          if (case1 === "P" || case2 === "P" || case3 === "P" || case4 === "P" || case5 === "P" || case6 === "P"
            || cased1 === "P" || cased2 === "P" || cased3 === "P" || cased4 === "P" || cased5 === "P" || cased6 === "P") {
            arrayReset[11].value = "normal"
          }
        }
      }
      
    } catch (e) {
      console.log(e);
    }
  };

  // const escapeRegExp = (text) => {
  //   return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // }

  const findParentSelection = (container, pElement) => {
    try{
      let parent = pElement.parentElement;
    
      while (parent) {
        if (parent === container) {
          return pElement;
        }
        pElement = pElement.parentElement
        parent = parent.parentElement;
      }
    
      return null; 
    }catch(er){
      console.log(er)
    }
    
  }

  const agroupInformationSelectForTheUser = (container) => {
    try{
      const selectedElements = window.getSelection();
      const selectedArray = [];

      if (selectedElements.rangeCount > 0) {
        const range = selectedElements.getRangeAt(0);
    
        if ((range.startContainer === range.endContainer) && (range.startContainer.nodeName === 'P' || range.startContainer.nodeName === 'CODE' || range.startContainer.nodeName === 'H2' || range.startContainer.nodeName === 'H3' || range.startContainer.nodeName === 'H4')) {
          selectedArray.push(range.startContainer);
        } else {
          const pElements = Array.from(container.querySelectorAll('p'));
          const codeElements = Array.from(container.querySelectorAll('code'));
          const h2Elements = Array.from(container.querySelectorAll('h2'));
          const h3Elements = Array.from(container.querySelectorAll('h3'));
          const h4Elements = Array.from(container.querySelectorAll('h4'));
          const divElements = Array.from(container.querySelectorAll('DIV'));
          selectedArray.push(
            ...pElements.filter(p => range.intersectsNode(p)),
            ...codeElements.filter(code => range.intersectsNode(code)),
            ...h2Elements.filter(h2 => range.intersectsNode(h2)),
            ...h3Elements.filter(h3 => range.intersectsNode(h3)),
            ...h4Elements.filter(h4 => range.intersectsNode(h4)),
            ...divElements.filter(div => range.intersectsNode(div)),
          );
        }
      }

      const groupedElements = [];
      
      for (const pElement of selectedArray) {
        const parent = findParentSelection(container, pElement);
        
        const existingGroup = groupedElements.find(group => group.father === parent);
        
        if (existingGroup) {
          existingGroup.children.push({ son: pElement, position: Array.from(parent.children).indexOf(findParentSelection(parent,pElement)) });
        } else {
          const group = {
            father: parent,
            children: (['P','CODE','H2','H3','H4','DIV'].includes(parent.tagName)) ? null : [{ son: pElement, position: Array.from(parent.children).indexOf(findParentSelection(parent,pElement)) }]
          };
          groupedElements.push(group);
        }
      }

      return groupedElements 

    }catch(er){
      console.log(er)
    }
  }

  const cssTextToObject = (cssText) => {
    const styleObject = {};
    const properties = cssText.split(';').filter(prop => prop.trim() !== '');
    
    properties.forEach(property => {
        const [key, value] = property.split(':').map(item => item.trim());
        styleObject[key] = value;
    });

    return styleObject;
}

  const onKeyDownHandler = (e, containerInput) => {
    try {
      range = document?.getSelection().getRangeAt(0);
      seleccion = window?.getSelection();
      const firstSon = range?.startContainer?.parentNode;
      const secondSon = range?.endContainer?.parentNode;
      const containerAll = document?.getElementById(`father-input-blog-${idClock}`);
      const getElementIndex = (element) => {
        try{
          const parent = element?.parentElement?.querySelectorAll("*");
          const children = Array.from(parent || []);
          return children.indexOf(element);
        }catch(er){
          console.log(er)
        }
      };
      
      if (esPadre(firstSon, containerAll) && esPadre(secondSon, containerAll)) {
        onChangeInformation(containerInput)
        const newP = document?.createElement("p");
        (newP || {setAttribute: () => {}}).setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
        (newP || {setAttribute: () => {}}).setAttribute("data-placeholder", "Write here");

        if (!containerInput?.children[0]) {
          (containerInput || {appendChild: () => {}}).appendChild(newP);
        }

        if (e?.type === 'keydown') {
          let key = e?.keyCode || e?.charCode;

          if (key === 8) {
            setTimeout(() => {
              const children = containerInput?.querySelectorAll('*');
              const childrenSpe = containerInput?.children;
              for (let i = 0; i < children?.length; i++) {
                if(['H2','H3','H4'].includes(children[i].tagName)) {
                  ((children[i] || {}).style || {}).cssText = "padding-top: 5px; padding-bottom: 5px; margin-top:20px !important; margin-bottom:20px !important;";
                }
                if (['FONT'].includes(children[i].tagName)) {
                  if ((children[i]?.textContent?.trim() === '') && i !== 0) {
                    (children[i] || {remove: () => {}}).remove();
                  }else{
                    const newSpan = document?.createElement("span");
                    (newSpan || {}).innerHTML = children[i]?.innerHTML;
                    if ((children[i] || {}).parentNode) {
                      ((children[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(newSpan, children[i]);
                    };
                  }
                }
                if (['SPAN'].includes(children[i].tagName)) {
                  const allowedStyles = ['color'];
                  const styleObject = cssTextToObject(children[i].style.cssText);
                  const newStyleObject = allowedStyles.reduce((acc, prop) => {
                    if (styleObject[prop]) {
                      acc[prop] = styleObject[prop];
                    }
                    return acc;
                  }, {});
                  const newCssText = Object.entries(newStyleObject).map(([key, value]) => `${key}: ${value};`).join(' ');
                  children[i].style.cssText = newCssText;
                }
              };
              for (let i = 0; i < childrenSpe?.length; i++){
                if (['DIV'].includes(childrenSpe?.[i]?.tagName) && childrenSpe?.[i]?.children?.length === 0){
                  (childrenSpe[i] || {removeAttribute: () => {}}).removeAttribute('style');
                  (childrenSpe[i] || {removeAttribute: () => {}}).removeAttribute('class');
                  const newP = document?.createElement("p");
                  (newP || {setAttribute: () => {}}).setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
                  (newP || {setAttribute: () => {}}).setAttribute("data-placeholder", "Write here");
                  (newP || {}).textContent = (childrenSpe?.[i] || {}).textContent;
                  if ((childrenSpe[i] || {}).parentNode) {
                    ((childrenSpe[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(newP, childrenSpe[i]);
                  }
                }
              }
            }, 400);

            const sel = (window || {getSelection: () => {}}).getSelection();
            const range = (sel || {getRangeAt: () => {}}).getRangeAt(0);
            const caretPos = (range || {startOffset: () => {}}).startOffset;
            
            const tag = agroupInformationSelectForTheUser(containerInput);
            const containsHsCtaEmbed = (node) => {
              if (node && node?.nodeType === Node?.ELEMENT_NODE) {
                  return (node?.classList || {contains: () => {}}).contains('hs-cta-embed');
              }
              return false;
            };
            e.stopPropagation();
            if(containsHsCtaEmbed(tag[0]?.father)){
              if(caretPos === 0){
                e.preventDefault();
                (tag[0]?.father || {remove: () => {}}).remove(); 
              }
            }
            if(containsHsCtaEmbed(tag[0]?.father?.previousSibling) || containsHsCtaEmbed(tag[0]?.father?.previousSibling?.children[0])){    
              if(caretPos === 0){
                e.preventDefault();
                (tag[0]?.father?.previousSibling || {remove: () => {}}).remove();
              }
            }
            if(tag[0]?.father?.previousSibling?.className === 'divider-container' || tag[0]?.father?.previousSibling?.className === 'container-insert' || tag[0]?.father?.previousSibling?.tagName === 'FIGURE'){
              if(caretPos === 0){
                e.preventDefault();
                (((tag[0] || {}).father || {}).previousSibling || {remove: () => {}}).remove();
              }
            }
            
          }
        }

        if(e.type === 'keydown' && e.key === 'Enter'){
          setTimeout(() => {
            const children = containerInput?.querySelectorAll('*');
            const childrenSpe = containerInput?.children;
            for (let i = 0; i < children?.length; i++) {
              let sonF = children?.[i];
              if(['H2','H3','H4'].includes(sonF?.tagName)) {
                ((sonF || {}).style || {}).cssText = "padding-top: 5px; padding-bottom: 5px; margin-top:20px !important; margin-bottom:20px !important;";
              }
              if (['FONT'].includes(sonF.tagName)) {
                if (((sonF?.textContent || '').trim() === '') && i !== 0) {
                  sonF.remove();
                }else{
                  const newSpan = document?.createElement("span");
                  (newSpan || {}).innerHTML = sonF?.innerHTML;
                  if (sonF?.parentNode) {
                    ((sonF || {}).parentNode || {replaceChild: () => {}}).replaceChild(newSpan, sonF);
                  }
                }
              }
              if (['SPAN'].includes(sonF?.tagName)) {
                let styleObject = cssTextToObject(sonF?.style?.cssText);
                const propertiesToInclude = ['color'];
                const hasAnyProperty = Object.keys(styleObject)?.length > 0;
                const containsDifferentProperties = (Object.keys(styleObject) || {some: () => {}}).some(prop => !propertiesToInclude?.includes(prop));
                if(hasAnyProperty && containsDifferentProperties){
                  let newStyles = '';
                  (Object.entries(styleObject) || []).map(e => {
                    if((propertiesToInclude || {includes:() => {}}).includes(e?.[0])){
                      newStyles = `${newStyles} ${e?.[0]}: ${e?.[1]};`;
                    };
                  })
                  ((sonF || {}).style || {}).cssText = newStyles;
                }
              }
            }
            for (let i = 0; i < childrenSpe?.length; i++){
              if (['DIV'].includes(childrenSpe?.[i]?.tagName) && childrenSpe?.[i]?.children?.length === 0){
                (childrenSpe[i] || {removeAttribute: () => {}}).removeAttribute('style');
                (childrenSpe[i] || {removeAttribute: () => {}}).removeAttribute('class');
                const newP = document?.createElement("p");
                (newP || {setAttribute: () => {}}).setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
                (newP || {setAttribute: () => {}}).setAttribute("data-placeholder", "Write here");
                (newP || {}).textContent = childrenSpe[i]?.textContent;
                if (childrenSpe[i]?.parentNode) {
                  ((childrenSpe[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(newP, childrenSpe[i]);
                }
              }
            }
          }, 200);
          
        }

        if (e?.type === 'keydown' && e?.key === 'Enter' && (((seleccion || {}).focusNode || {}).parentElement || {}).tagName === "CODE") {
        
          e.preventDefault();
          e.stopPropagation()

          let elemento = ((seleccion || {}).focusNode || {}).parentElement;
          let contenidoActual = elemento?.textContent;
    

          let puntoInsercion = range?.endOffset;

          let textoAntes = (contenidoActual || {substring: () => {}}).substring(0, puntoInsercion);
          let textoDespues = (contenidoActual || {substring: () => {}}).substring(puntoInsercion);
          let nuevoContenido = textoAntes + "\n" + textoDespues;

          (elemento || {}).textContent = nuevoContenido;

          let nuevoRange = document?.createRange();
          (nuevoRange || {setStart: () => {}}).setStart(elemento.childNodes[0], puntoInsercion + 1);
          (nuevoRange || {collapse: () => {}}).collapse(true);
          (seleccion || {removeAllRanges: () => {}}).removeAllRanges();
          (seleccion || {addRange: () => {}}).addRange(nuevoRange);
    
        }

        if (e.type === 'keydown' && e.key === 'Enter' && seleccion?.focusNode?.parentElement.tagName === "FIGCAPTION") {
        
          e.preventDefault();
          e.stopPropagation()

          let elemento = seleccion?.focusNode?.parentElement?.parentElement;
          const newP = document.createElement("p");
          newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
          newP.setAttribute("data-placeholder", "Write here");
          containerInput.insertBefore(newP, elemento?.nextSibling)

        }

        if ((e.type === 'keydown' && e.key === 'Enter' && (seleccion.focusNode || {}).parentElement?.tagName === "FIGURE")) {

          e.preventDefault();
          e.stopPropagation();
      
          let elemento = (seleccion || {}).focusNode?.parentElement;
          const newP = document.createElement("p");
          newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
          newP.setAttribute("data-placeholder", "Write here");
          containerInput.insertBefore(newP, elemento?.nextSibling);
        }
      
        if (e.ctrlKey && e.type === 'keydown' && e.key === 'v') {
        
            if ((seleccion || {}).focusNode) {
                if (seleccion.focusNode.tagName === 'FIGCAPTION') {
                    bulFigcaption = seleccion.focusNode;
                }
            }
            let elemento = ((seleccion.focusNode || {}).parentElement || {}).id === `container-blog-input-${idClock}`
                ? seleccion.focusNode
                : (((seleccion.focusNode || {}).parentElement || {}).parentElement || {}).id === `container-blog-input-${idClock}`
                    ? (seleccion.focusNode || {}).parentElement
                    : ((((seleccion.focusNode || {}).parentElement || {}).parentElement || {}).parentElement || {}).id === `container-blog-input-${idClock}`
                        ? ((seleccion.focusNode || {}).parentElement || {}).parentElement
                        : (((((seleccion.focusNode || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).id === `container-blog-input-${idClock}`
                            ? (((seleccion.focusNode || {}).parentElement || {}).parentElement || {}).parentElement
                            : ((((((seleccion.focusNode || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement || {}).id === `container-blog-input-${idClock}`
                            && ((((seleccion.focusNode || {}).parentElement || {}).parentElement || {}).parentElement || {}).parentElement;
        
            const newP = document.createElement("p");
            newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
            newP.setAttribute("data-placeholder", "Write here");
            containerInput.insertBefore(newP, elemento?.nextSibling);
        
            newP.focus();
            let rangoFinish = document.createRange();
        
            rangoFinish.setStart(newP, 0);
            rangoFinish.collapse(true);
        
            seleccion.removeAllRanges();
            seleccion.addRange(rangoFinish);
        
            if ((elemento?.textContent === '' || elemento?.textContent === ' ') && ((seleccion.focusNode || {}).parentElement?.tagName === "FIGURE" || (seleccion.focusNode || {}).parentElement?.tagName === "FIGCAPTION")) {
              (elemento || {remove: () => {}}).remove();
            }
        
            let interContainer = containerInput.cloneNode(true);
        
            lengthBeforeContainer.current = interContainer.querySelectorAll('*').length;
        }
      

        if (e.type === 'paste') {
          e.preventDefault();
          const text = (((e.originalEvent || e) || {}).clipboardData || {getData: () => {}}).getData('text/html');
          const text2 = (((e.originalEvent || e) || {}).clipboardData || {getData: () => {}}).getData('text');
          let key = `child-position-${uuidv4()}`;
          const newDiv = document?.createElement("div");
          (newDiv || {}).innerHTML = text;
          const groupedElementsPaste = agroupInformationSelectForTheUser(containerInput);

          const getChildrenUntilMultipleChildren = (element) => {
            const traverse = (element) => {
                const children = Array.from(element.children);
                const fragment = document?.createDocumentFragment();
                if (children?.length > 1 && (children[0]?.tagName !== 'META' || (children || []).some(e => e.tagName === 'P'))) {
                  (children || []).forEach(child => {
                    if(['UL', 'OL', 'DIV', 'FIGURE', 'BLOCKQUOTE', 'PRE', 'LI', 'A', 'H2', 'H3', 'H4','BUTTON','P'].includes(child.tagName)){
                      (fragment || {appendChild: () => {}}).appendChild(child)
                    }
                  });
                  return fragment
                } else if (children?.length > 1) {
                  let caseChildren = children[0]?.tagName === 'META'
                    ? children[1]?.tagName === 'META'
                      ? children[2]?.tagName === 'META'
                        ? children[3]?.tagName === 'META'
                          ? children[4]
                          : children[3]
                        : children[2]
                      : children[1]
                    : children[0]
                  return traverse(caseChildren);
                }
            }
    
            let data = traverse(element);
    
            return data;
          }

          if(!text){
            if ((groupedElementsPaste[0]?.father?.textContent || '').trim() === '' && groupedElementsPaste[0]?.father?.tagName === "P") {
              (indexPaste || {}).current = getElementIndex(groupedElementsPaste[0]?.father);
              ((groupedElementsPaste[0] || {}).father || {}).id = key;
              ((groupedElementsPaste[0] || {}).father || {}).textContent = text2;
            } else {
              const newParagraph = document.createElement('p');
              (newParagraph || {}).id = key;
              (newParagraph || {}).textContent = text2;
              (indexPaste || {}).current = getElementIndex(groupedElementsPaste[0]?.father?.nextSibling);
              (containerInput || {insertBefore: () => {}}).insertBefore(newParagraph, groupedElementsPaste[0]?.father?.nextSibling);
            }
          }else{
            const resultFragment = getChildrenUntilMultipleChildren(newDiv);

            if ((((groupedElementsPaste[0] || {}).father || {}).textContent || '').trim() === '' && groupedElementsPaste[0]?.father?.tagName === "P") {
              (indexPaste || {}).current = getElementIndex(groupedElementsPaste[0]?.father);
              if(groupedElementsPaste[0]?.father?.parentNode){
                (groupedElementsPaste[0]?.father?.parentNode || {replaceChild: () => {}}).replaceChild(resultFragment, groupedElementsPaste[0]?.father);
              }
            } else {
              (indexPaste || {}).current = getElementIndex(groupedElementsPaste[0]?.father?.nextSibling);
              (containerInput || {insertBefore: () => {}}).insertBefore(resultFragment, groupedElementsPaste[0]?.father?.nextSibling);
            }
          }
          
          let lengthBeforeContainerr = lengthBeforeContainer?.current;
          let indexPaster = indexPaste?.current;
        
          //formatting system when pasting documents
          setTimeout(() => {
            try {
              const children = containerInput?.querySelectorAll('*');
        
              const rang = (children?.length-lengthBeforeContainerr)+indexPaster;

              for (let i = 0; i < children?.length; i++) {
                if(i >= indexPaster && i <= rang){
                  let estilo = (window || {getComputedStyle: () => {}}).getComputedStyle(children[i]);
                  let fontWeight = (estilo || {getPropertyValue: () => {}}).getPropertyValue('font-weight');
                  let fontStyle = (estilo || {getPropertyValue: () => {}}).getPropertyValue('font-style');
                  let colorStyle1 = children[i]?.style;
                  if (children[i]?.tagName === 'P') {
                    (children[i] || {setAttribute: () => {}}).setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
                    (children[i] || {setAttribute: () => {}}).setAttribute("data-placeholder", "Write here");
                    if (/\n/.test(children[i]?.textContent)) {
                      const newDiv = document?.createElement("div");
                      const fragmento = document?.createDocumentFragment();

                      let newP = `<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${children[i].innerHTML.replaceAll('\n', '</p><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">').replace(/ {3,}/g, '</p><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">')}</p>`;

                      (newDiv || {}).innerHTML = newP;

                      for (const child of newDiv?.children) {
                        const clonedChild = child?.cloneNode(true);
                        (clonedChild || {}).id = `child-position-${uuidv4()}`;

                        (fragmento || {appendChild: () => {}}).appendChild(clonedChild);
                      }
            
                      if (children[i]?.parentElement) {
                        (children[i] || {replaceWith: () => {}}).replaceWith(fragmento);
                      }
                    }
                  }
                  if(children[i]?.tagName === 'BR' && children[i]?.parentElement?.id === `container-blog-input-${idClock}`){
                    (children[i] || {remove: () => {}}).remove();
                  }
                  if (children[i]?.tagName === 'UL' || children[i]?.tagName === 'OL' || children[i]?.tagName === 'LI') {
                    (children[i] || {setAttribute: () => {}}).setAttribute("style", "");
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                  }
                  if (children[i]?.tagName === 'FIGURE') {
                    (children[i] || {setAttribute: () => {}}).setAttribute("style", 'margin:10px 0px; display: flex; flex-direction: column; width: 100%; justify-content: flex-start; height: auto;');
                  }
                  if (children[i]?.tagName === "BLOCKQUOTE") {
                    (children[i] || {setAttribute: () => {}}).setAttribute("class", "blockquote-style");
                    (children[i] || {setAttribute: () => {}}).setAttribute("style", "border-left: 2px solid #56687a; padding-left: 5px; text-align: left; color: #56687a;");
                  }
                  if (children[i]?.tagName === "STRONG") {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                    const nuevoB = document?.createElement('b');
                    (nuevoB || {}).textContent = children[i]?.textContent;
                    if (children[i]?.parentNode) {
                      try{
                        ((children[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(nuevoB, children[i]);
                      }catch(er){
                        console.log(er)
                      }
                    }
                  }
                  if (children[i]?.tagName === "EM") {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                    const nuevoI = document?.createElement('i');
                    (nuevoI || {}).textContent = children[i]?.textContent;
                    if (children[i]?.parentNode) {
                      try{
                        ((children[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(nuevoI, children[i]);
                      }catch(er){
                        console.log(er)
                      }
                    }
                  }
                  if (children[i]?.tagName === "H2" || children[i]?.tagName === "H3" || children[i]?.tagName === "H4") {
                    (children[i] || {setAttribute: () => {}}).setAttribute("style", "padding-top: 5px; padding-bottom: 5px; margin-top:20px !important; margin-bottom:20px !important;");
                    const childrens = children[i]?.querySelectorAll('*');

                    for (let y = 0; y < childrens?.length; y++) {
                      const texto = document?.createTextNode(childrens[y].textContent);
                      if (children[i]) {
                        try{
                          (children[i] || {replaceChild: () => {}}).replaceChild(texto, childrens[y]);
                        }catch(er){
                          console.log(er)
                        }
                      }
                    
                    }
                  }
                  if (children[i].tagName === "H1") {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                    const nuevoH2 = document?.createElement('H2');
                    (nuevoH2 || {}).textContent = children[i]?.textContent;
                    (nuevoH2 || {setAttribute: () => {}}).setAttribute("style", "padding-top: 5px; padding-bottom: 5px; margin-top:20px !important; margin-bottom:20px !important;");
                    if (children[i]?.parentNode) {
                      try{
                        ((children[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(nuevoH2, children[i]);
                      }catch(er){
                        console.log(er)
                      }
                    }
                  }
                  if (children[i]?.tagName === "PRE") {
                    (children[i] || {setAttribute: () => {}}).setAttribute("class", "code-style");
                    (children[i] || {setAttribute: () => {}}).setAttribute("style", "white-space: pre-wrap; color: #fff; font-size: 16px; line-height: 16px; background: #293138; border-radius: 15px; display: block; white-space: pre; overflow-x: auto;");
                  }
      
                  if ((parseInt(fontWeight || '') >= 650 || fontWeight === 'bold') && !['UL', 'OL', 'DIV', 'FIGURE', 'BLOCKQUOTE', 'PRE', 'LI', 'A', 'H2', 'H3', 'H4','BUTTON'].includes(children[i]?.tagName)) {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                  }
                  if ((parseInt(fontWeight || '') >= 650 || fontWeight === 'bold') && !['UL', 'OL', 'DIV', 'FIGURE', 'BLOCKQUOTE', 'PRE', 'LI', 'A', 'H2', 'H3', 'H4','BUTTON'].includes(children[i]?.tagName)) {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                    const nuevoB = document?.createElement('b');
                    (nuevoB || {}).textContent = children[i]?.textContent;
                    if (children[i]?.parentNode) {
                      try{
                        ((children[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(nuevoB, children[i]);
                      }catch(er){
                        console.log(er)
                      }
                    }
                  }
                  if (fontStyle === 'italic' && !['UL', 'OL', 'DIV', 'FIGURE', 'BLOCKQUOTE', 'PRE', 'LI', 'A', 'H2', 'H3', 'H4','BUTTON'].includes(children[i].tagName)) {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                  }
                  if (fontStyle === 'italic' && !['UL', 'OL', 'DIV', 'FIGURE', 'BLOCKQUOTE', 'PRE', 'LI', 'A', 'H2', 'H3', 'H4','BUTTON'].includes(children[i].tagName)) {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                    const nuevoI = document?.createElement('i');
                    (nuevoI || {}).textContent = children[i]?.textContent;
                    if (children[i]?.parentNode) {
                      try{
                        ((children[i] || {}).parentNode || {replaceChild: () => {}}).replaceChild(nuevoI, children[i]);
                      }catch(er){
                        console.log(er)
                      }
                    }
                  }
                  if (((fontStyle !== 'italic' || parseInt(fontWeight || '') < 650 || fontWeight !== 'bold') 
                  && (colorStyle1[0] !== 'color' && !colorStyle1[1] && children[i]?.tagName === 'SPAN')) 
                  && !['P', 'UL', 'OL', 'DIV', 'FIGURE', 'BLOCKQUOTE', 'PRE', 'LI', 'A', 'H2', 'H3', 'H4'].includes(children[i].tagName)) {
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                    (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                  }
                }
              }
              setTimeout(() => {
                try {
                  const children = containerInput?.querySelectorAll('*');

                  const rang = (children?.length-lengthBeforeContainerr)+indexPaster
                  for (let i = 0; i < children?.length; i++) {
                    if(i >= indexPaster && i <= rang){
                      if (['P', 'BLOCKQUOTE'].includes(children[i]?.tagName)) {
                        // const childrens = children[i]?.querySelectorAll('*');
                        // for (let y = 0; y < childrens?.length; y++) {
                        //   // let styles = childrens[y].style
                        //   // if (!['B', 'I', 'A'].includes(childrens[y].tagName)) {
                        //   //   const texto = document.createTextNode(childrens[y].textContent);
                        //   //   if (childrens[y].parentNode) {
                        //   //     childrens[y].parentNode.replaceChild(texto, childrens[y]);
                        //   //   }
                        //   // }
                        // }
                      }
                      if (['UL', 'OL'].includes(children[i]?.tagName)) {
                        const childrens = children[i]?.children;
                        for (let y = 0; y < childrens?.length; y++) {
                          if (!['LI'].includes(childrens[y]?.tagName)) {
                            const nuevoLi = document?.createElement('li');
                            (nuevoLi || {}).textContent = childrens[y]?.textContent;
                            if (children[y]?.parentNode) {
                              (childrens[y].parentNode || {replaceChild:() => {}}).replaceChild(nuevoLi, childrens[y]);
                            }
                          }
                        }
                      }
                      if (children[i]?.tagName === "H2") {
                        const childrens = children[i]?.children;
                        for (let y = 0; y < childrens.length; y++) {
                          const texto = document?.createTextNode(childrens[y]?.textContent);
                          if (childrens[y]?.parentNode) {
                            (childrens[y].parentNode ||  {replaceChild:() => {}}).replaceChild(texto, childrens[y]);
                          }
                        }
                      }
                    }
                    
                  }
                  setTimeout(() => {
                    try {
                      const children = containerInput?.querySelectorAll('*');
                      const rang = (children?.length-lengthBeforeContainerr)+indexPaster;
                      for (let i = 0; i < children?.length; i++) {
                        if(i >= indexPaster && i <= rang){
                          if (['B'].includes(children[i]?.tagName)) {
                            if ((children[i]?.textContent || '').trim() === '') {
                              (children[i] || {remove: () => {}}).remove();
                            }
                          }
                        }
                        
                      }
                      setTimeout(() => {
                        try {
                          const children = containerInput?.querySelectorAll('*');
                          const rang = (children?.length-lengthBeforeContainerr)+indexPaster;
                          bulFigcaption = false;
                          for (let i = 0; i < children?.length; i++) {
                            const findParent = (element, type) => {
                              let parent = element.closest(type);
                              let position = parent ? (Array.from(parent.querySelectorAll('p')) || {indexOf: () => {}})?.indexOf(element) : null;
                              return parent ? { parent, position } : { parent: null, position: null };
                            }
                            if(i >= indexPaster && i <= rang){
                              if (['DIV'].includes(children[i]?.tagName) && !findParent(children[i], 'figure')?.position 
                              && !(children[i]?.className === 'divider-container' || children[i]?.className === 'button-container-input' || children[i]?.parentElement?.className === 'divider-container' || children[i]?.parentElement?.className === 'button-container-input')) {
                                (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                                (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                                const newP = document?.createElement("p");
                                (newP || {setAttribute: () => {}}).setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
                                (newP || {setAttribute: () => {}}).setAttribute("data-placeholder", "Write here");
                                (newP || {}).textContent = children[i]?.textContent;
                                if (children[i]?.parentNode) {
                                  try{
                                    (children[i].parentNode || {replaceChild: () => {}}).replaceChild(newP, children[i]);
                                  }catch(er){
                                    console.log(er);
                                  }
                                }
                              }
                              if (['LI'].includes(children[i]?.tagName)) {
                                if (children[i]?.children[0] === undefined) {
                                  children[i].innerHTML = `<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${children[i]?.textContent}</p>`;
                                } else {
                                  if (children[i]?.children[0]?.tagName !== 'P') {
                                    children[i].innerHTML = `<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${children[i]?.textContent}</p>`;
                                  }
                                }
                              }
                            }
                            if (['DIV'].includes(children[i]?.tagName) && !findParent(children[i], 'figure')?.position 
                              && !(children[i]?.className === 'divider-container' || children[i]?.className === 'button-container-input' || children[i]?.parentElement?.className === 'divider-container' || children[i]?.parentElement?.className === 'button-container-input')){
                              (children[i] || {removeAttribute: () => {}}).removeAttribute('style');
                              (children[i] || {removeAttribute: () => {}}).removeAttribute('class');
                              const newP = document?.createElement("p");
                              (newP || {setAttribute: () => {}}).setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
                              (newP || {setAttribute: () => {}}).setAttribute("data-placeholder", "Write here");
                              (newP || {}).textContent = children[i].textContent;
                              if (children[i]?.parentNode) {
                                try{
                                  (children[i].parentNode || {replaceChild: () => {}}).replaceChild(newP, children[i]);
                                }catch(er){
                                  console.log(er)
                                }
                              }
                            }
                            if (['P'].includes(children[i]?.tagName)) {
                              if ((children[i]?.textContent?.trim() === '') && i !== 0) {
                                (children[i] || {remove: () => {}}).remove();
                              }else{
                                ((children[i] || {}).style || {}).cssText = 'color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;';
                              }
                            }
                            if(['H2','H3','H4'].includes(children[i]?.tagName)) {
                              ((children[i] || {}).style || {}).cssText = "padding-top: 5px; padding-bottom: 5px; margin-top:20px !important; margin-bottom:20px !important;";
                            }
                            if (['FONT'].includes(children[i]?.tagName)) {
                              if ((children[i]?.textContent?.trim() === '') && i !== 0) {
                                (children[i] || {remove: () => {}}).remove();
                              }else{
                                const newSpan = document?.createElement("span");
                                (newSpan || {}).innerHTML = children[i]?.innerHTML;
                                if (children[i]?.parentNode) {
                                  try{
                                    (children[i].parentNode || {replaceChild: () => {}}).replaceChild(newSpan, children[i]);
                                  }catch(er){
                                    console.log(er)
                                  }
                                }
                              }
                            }
                            if (['SPAN'].includes(children[i]?.tagName)) {
                              let styleObject = cssTextToObject(children[i]?.style?.cssText);
                              const propertiesToInclude = ['color'];
                              const hasAnyProperty = Object.keys(styleObject)?.length > 0;
                              const containsDifferentProperties = Object.keys(styleObject)?.some(prop => !propertiesToInclude?.includes(prop));
                              if(hasAnyProperty && containsDifferentProperties){
                                let newStyles = '';
                                Object.entries(styleObject).map(e => {
                                  if(propertiesToInclude.includes(e?.[0])){
                                    newStyles = `${newStyles} ${e?.[0]}: ${e?.[1]};`;
                                  }
                                });
                                children[i].style.cssText = newStyles;
                              }
                            }
                            if (['SPAN'].includes(children[i]?.tagName)) {
                              let bulIsChildren = (children[i]?.id || {startsWith: () => {}}).startsWith('child-position-');
                              if(bulIsChildren){
                                const newP = document?.createElement("p");
                                (newP || {setAttribute: () => {}}).setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
                                (newP || {setAttribute: () => {}}).setAttribute("data-placeholder", "Write here");
                                const clonedChild = (children[i] || {cloneNode: () => {}}).cloneNode(true);
                                (newP || {}).innerHTML = clonedChild?.textContent;
                                if (children[i]?.parentNode) {
                                  try{
                                    (children[i].parentNode || {replaceChild: () => {}}).replaceChild(newP, children[i]);
                                  }catch(er){
                                    console.log(er);
                                  }
                                }
                              }
                            }
                          }
                        } catch (er) {
                          console.log(er)
                        }
                      }, 50);
                    } catch (er) {
                      console.log(er)
                    }
                  
                  }, 50);
                } catch (er) {
                  console.log(er)
                }
              }, 100);
            } catch (er) {
              console.log(er)
            }
          
          }, 100);
        }
      }
    }catch(er){
      console.log(er)
    }
  };

  const ctrlZFunction = (e,containerInput) => {
    try {
      
      let index = 0
      let elementIndex = document.querySelectorAll(".container-html-editable")
      elementIndex.forEach((e,ind) => {
        if(esPadre(containerInput, e.parentElement)){
          index = ind
        }
      })
      
      range = document.getSelection().getRangeAt(0);
      seleccion = window.getSelection();
      const firstSon = (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
      const secondSon =  (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode
      const containerAll = document.getElementById(`father-input-blog-${idClock}`);

      if (esPadre(firstSon, containerAll) && esPadre(secondSon, containerAll)) {
        if (e.type === 'keydown' && e.ctrlKey && e.key === 'z') {

          e.preventDefault();
          e.stopPropagation();

          let contentZZ = JSON.parse(localStorage.getItem('contentZ'))
          let contentZ = contentZZ[index] ? contentZZ[index] : []
      
          if (contentZ[contentZ.length - 2] !== undefined) {
            containerInput.innerHTML = contentZ[contentZ.length - 2];

            contentZ.pop()

            localStorage.setItem('contentZ', JSON.stringify({...contentZZ,[index]:contentZ}))
          }
        }
      }
    }catch(er){
      console.log(er)
    }
  }

  const filterWidthsElements = (container) => {
    try{
      let figureData = container.querySelectorAll("figure");

      for(let i = 0; i < figureData.length; i++){

        figureData[i].style.cssText = `margin:10px 0px; display: flex; flex-direction: column; width: 100%; justify-content: center; align-items:center; height: auto;`;
        if (figureData[i].children[0].className === "container-image-range") {
          const inputRange = figureData[i].children[0].querySelector('.input-range')
          let value = figureData[i].children[0].style.width;
          const regex = /\d+/g;
          const match = value.match(regex);
          inputRange.value = match[0]
          inputRange.defaultValue = match[0];
        } else {
          figureData[i].children[0].style.width = (figureData[i].children[0].className === "container-image-expand") ? "50%" : "100%";
        }
        // figureData[i].children[0].children[1].children[0].style.cssText = `filter: none; height: auto; width: 100%;"height: auto; width: 100%;`

      }
      
      return container.outerHTML
    }catch(er){
      console.log(er)
    }
  }

  const filterElements = (element) => {
    try{
      let newElement = element.replaceAll(`<div class="btn-delete-divider"></div>`,'<div id="replace-diivider" style="display:none;"></div>')
      newElement = newElement.replaceAll(`<div class="container-image-buttons"`,`<div style="display:none;" class="container-image-buttons"`)
      newElement = newElement.replaceAll(`<div class="container-buton-buttons"`,`<div class="container-buton-buttons" style="display:none;"`)
      return newElement
    }catch(er){
      console.log(er)
    }
  }

  const processExec = (type, complement) => {
    if (complement) {
      document.execCommand(type, true, complement);
    } else {
      document.execCommand(type);
    }
  };

  const processModalA = (text) => {
    try{
      const containerInput = document.getElementById(`container-blog-input-${idClock}`);
      if(bulA){

        const selection = window.getSelection();
        const selectedAnchors = [];

        for (let i = 0; i < selection.rangeCount; i++) {
            const range = selection.getRangeAt(i);
            const container = range.commonAncestorContainer;

            // Verifica si el elemento contiene enlaces <a>
            if (container.nodeType === Node.ELEMENT_NODE) {
                const anchorElements = container.getElementsByTagName('a');
                for (const anchor of anchorElements) {
                    // Verifica si la selección incluye este enlace
                    if (selection.containsNode(anchor, true)) {
                        selectedAnchors.push(anchor);
                    }
                }
            }
        }

        for(let i = 0; i < selectedAnchors.length; i++){
          const texto = document.createTextNode(selectedAnchors[i].textContent);
          selectedAnchors[i].parentNode.replaceChild(texto, selectedAnchors[i]);
        }

        onChangeInformation(containerInput)
        
      }else{
        setRangeForLink(document.getSelection().getRangeAt(0));
        setTextModal(text);
        onChangeInformation(containerInput)
      }
      
    }catch(er){
      console.log(er)
    }
  };

  const refactoringLinkError = (brs) => {
    if (brs.length > 0) {
      const newP = document.createElement('p');
      brs.forEach(br => {
        newP.style.color = 'rgba(0,0,0,0.9)';
        newP.style.fontSize = '14px';
        newP.style.lineHeight = '16px';
        newP.style.marginTop = '20px !important';
        newP.style.marginBottom = '20px !important';
        newP.setAttribute('contenteditable', 'true');
        newP.setAttribute('data-placeholder', 'Write here');
        newP.appendChild(document.createElement('br'));
        newP.id = br.id;
        br.parentNode.replaceChild(newP, br);
      });

      const newSelection = window.getSelection();
      const nuevoRango = document.createRange();
      nuevoRango.selectNodeContents(newP);
      newSelection.removeAllRanges();
      newSelection.addRange(nuevoRango);
      return seleccion = newSelection

    } else {
      return seleccion = window.getSelection();
    }
  }

  const processModalInsert = (text) => {
    try{
      const containerInput = document.getElementById(`container-blog-input-${idClock}`);
      setRangeForLink(document.getSelection().getRangeAt(0));
      setTextModal(text);
      onChangeInformation(containerInput)
    }catch(er){
      console.log(er)
    }
  };

  const createLink = () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(rangeForLink);
      processExec("createLink", Link);
      setTextModal("");
      onChangeInformation(containerInput)
    }catch(er){
      console.log(er)
    }
    
  };

  const deleteDivider = (e) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      e.target.parentNode.remove();
      onChangeInformation(containerInput)
    }catch(er){
      console.log(er)
    }
  };

  const setEventToDeleteDivider = (idfos) => {
    try{
      const containerInput = document.getElementById(`container-blog-input-${idClock}`);
      const elementWithNumericId = containerInput.querySelector(`[id="${idfos}"]`);
      if (elementWithNumericId) {
        elementWithNumericId.children[1].addEventListener("click", deleteDivider);
      } else {
        setTimeout(() => {
          setEventToDeleteDivider(idfos);
        }, 200);
      }
    }catch(er){
      console.log(er)
    }
    
  };

  const generateDivider = () => {
    try{
      const Id = moment().format("YYYYMMDDhhmmssSSS");
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);

      const brs = containerInput.querySelectorAll('div > br');
      seleccion = refactoringLinkError(brs)

      let elemento = (seleccion.focusNode.parentElement.id === `container-blog-input-${idClock}`)
        ? seleccion.focusNode
        : (seleccion.focusNode.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
          ? seleccion.focusNode.parentElement
          : (seleccion.focusNode.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
            ? seleccion.focusNode.parentElement.parentElement
            : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
              ? seleccion.focusNode.parentElement.parentElement.parentElement
              : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
                && seleccion.focusNode.parentElement.parentElement.parentElement.parentElement

      const newP = document.createElement("p");
      newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:0px !important;");
      containerInput.insertBefore(newP,elemento.nextSibling)
      
      newP.focus()
      let rangoFinish = document.createRange();
  
      rangoFinish.setStart(newP, 0);
      rangoFinish.collapse(true);

      seleccion.removeAllRanges();
      seleccion.addRange(rangoFinish);

      if(seleccion){
        if(seleccion.focusNode){
          if((elemento.textContent === '' || elemento.textContent === ' ') && (seleccion.focusNode.parentElement.tagName === "FIGURE" || seleccion.focusNode.parentElement.tagName === "FIGCAPTION")){
            elemento.remove()
          }
        }
      }
      
      document.execCommand(
        "insertHTML",
        true,
        `<div id="${Id}" contenteditable="false" readonly class="divider-container" style="position: relative; display: flex; flex-direction: column; padding: 12px 0;"><hr readonly class="hr-divider" style="margin: 0;" /><div class="btn-delete-divider"></div></div>`
      );
      newP.remove()

      const newDiv = document.getElementById(Id);
      if (!newDiv.nextElementSibling) {
        const newParagraph = document.createElement('p');
        newParagraph.style.color = 'rgba(0,0,0,0.9)';
        newParagraph.style.fontSize = '14px';
        newParagraph.style.lineHeight = '16px';
        newParagraph.style.marginTop = '20px !important';
        newParagraph.style.marginBottom = '20px !important';
        newParagraph.contentEditable = true;
        newParagraph.dataset.placeholder = 'Write here';
      
        newDiv.parentNode.insertBefore(newParagraph, newDiv.nextSibling);
      }
  
      setEventToDeleteDivider(Id); 
    }catch(er){
      console.log(er)
    }
  };

  const setEventsToButton = (Id,Id2,Id3) => {
    const container2 = document.getElementById(Id2);
    const container3 = document.getElementById(Id3);
  
    if (container2 && container3) {
      container2.addEventListener("click", () => editButton(Id));
      container3.addEventListener("click", () => deleteButton(Id));
    } else {
      setTimeout(() => {
        setEventsToButton(Id,Id2,Id3);
      }, 200);
    }
  };

  const generateButton = async () => {
    try {
      const containerInput = document.getElementById(`container-blog-input-${idClock}`);

      const Id = moment().format("YYYYMMDDhhmmssSSS-1");
      const Id2 = moment().format("YYYYMMDDhhmmssSSS-2");
      const Id3 = moment().format("YYYYMMDDhhmmssSSS-3");
  
      const brs = containerInput.querySelectorAll('div > br');
      seleccion = refactoringLinkError(brs)
  
      let elemento = (seleccion.focusNode.parentElement.id === `container-blog-input-${idClock}`)
        ? seleccion.focusNode
        : (seleccion.focusNode.parentElement.parentElement.id === `container-blog-input-${idClock}`)
          ? seleccion.focusNode.parentElement
          : (seleccion.focusNode.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`)
            ? seleccion.focusNode.parentElement.parentElement
            : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`)
              ? seleccion.focusNode.parentElement.parentElement.parentElement
              : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`)
              && seleccion.focusNode.parentElement.parentElement.parentElement.parentElement;
  
      const newP = document.createElement("p");
      newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
      newP.setAttribute("data-placeholder", "Write here");
      containerInput.insertBefore(newP, elemento.nextSibling);
  
      newP.focus();
      let rangoFinish = document.createRange();
  
      rangoFinish.setStart(newP, 0);
      rangoFinish.collapse(true);
  
      seleccion.removeAllRanges();
      seleccion.addRange(rangoFinish);
  
      if (seleccion) {
        if (seleccion.focusNode) {
          if ((elemento.textContent === '' || elemento.textContent === ' ') && (seleccion.focusNode.parentElement.tagName === "FIGURE" || seleccion.focusNode.parentElement.tagName === "FIGCAPTION")) {
            elemento.remove();
          }
        }
      }
        
      document.execCommand(
        "insertHTML",
        true,
        `<div contenteditable="false" readonly class="button-container-input" style="position: relative; display: flex; flex-direction: column; padding: 12px 0;"><a id="custom-link-redirect" style="cursor: auto; color: inherit; text-decoration: none; display: flex;"><button id="custom-button-${Id}" class="custom-button" style="width: max-content; margin: 0 auto; cursor: pointer">Button</button></a><div class="container-buton-buttons"><div class="container-buton-buttons-inter" contenteditable="false" display: flex; justify-content: center; align-items: center; margin: 0 auto; overflow: hidden; position: relative; transition: all 0.5s ease-in-out;"><button type="button" title="Edit button" aria-label="Edit" id="${Id2}" style=" height: 31px; width: 31px; border-radius: 50%; border: 1px solid #aaa; cursor: pointer;"><li-icon aria-hidden="true" type="edit" size="small"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false"><path d="M14.13 1.86a3 3 0 00-4.17 0l-7 7L1 15l6.19-2 6.94-7a3 3 0 000-4.16zm-8.36 9.71l-1.35-1.34L9.64 5 11 6.35z"></path></svg></li-icon></button><button title="Remove button" type="button" aria-label="Remove" id="${Id3}" style=" height: 31px; width: 31px; border-radius: 50%; border: 1px solid #aaa; cursor: pointer;"><li-icon aria-hidden="true" type="cancel" size="small"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false"><path d="M14 3.41L9.41 8 14 12.59 12.59 14 8 9.41 3.41 14 2 12.59 6.59 8 2 3.41 3.41 2 8 6.59 12.59 2z"></path></svg></li-icon></button></div></div></div><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" contenteditable="true" data-placeholder="Write here"></p>`
      );
  
      newP.remove();
  
      setEventsToButton(`custom-button-${Id}`,Id2,Id3);

    } catch (er) {
      console.log(er);
    }
  };

  const getBase64 = (file) => {
    try{
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }catch(er){
      console.log(er)
    }
  }

  const expandImage = (id) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const containerImageExpandSelect = document.getElementById(id);

      if (containerImageExpandSelect.className === "container-image-range") {
        containerImageExpandSelect.className = "container-image-expand"
      }
      
      containerImageExpandSelect.style.width = (containerImageExpandSelect.className === "container-image-expand")
        ? `${containerInput.clientWidth - 40}px`
        : `${(containerInput.clientWidth / 2) - 40}px`

      containerImageExpandSelect.className = (containerImageExpandSelect.className === "container-image-expand")
        ? "container-image-expand-2"
        : "container-image-expand"

      onChangeInformation(containerInput)

    }catch(er){
      console.log(er)
    }
    
  }

  const setVideoSize = (id) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const containerImageExpandSelect = document.getElementById(id);
      containerImageExpandSelect.parentElement.parentElement.parentElement.parentElement.style.width = `${containerImageExpandSelect.value}%`
      containerImageExpandSelect.parentElement.parentElement.parentElement.parentElement.style.margin = '0 auto'

      onChangeInformation(containerInput)

    }catch(er){
      console.log(er)
    }
    
  }

  const setImageSize = (id) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const containerImageExpandSelect = document.getElementById(id);
      containerImageExpandSelect.parentElement.parentElement.parentElement.style.width = `${containerImageExpandSelect.value}%`
      containerImageExpandSelect.parentElement.parentElement.parentElement.className = "container-image-range";

      onChangeInformation(containerInput)

    }catch(er){
      console.log(er)
    }
    
  }

  const addChangesImage = () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const containerImageModal = document.getElementById("modal-container-image");
      const linkImage = document.getElementById("link-text-related");
      const altImage = document.getElementById("alt-text-related");
      const codeImage = document.getElementById("code-text-related")
      const imageSelectedC = document.getElementById(codeImage.value);

      imageSelectedC.alt = (altImage.value === "" || altImage.value === " ") ? "#" : altImage.value
      imageSelectedC.parentElement.href = linkImage.value
      altImage.value = ''
      linkImage.value = ''
      containerImageModal.style.display = "none"
      onChangeInformation(containerInput)
    }catch(er){
      console.log(er)
    }
  }

  const editImage = (id,IdImage) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const containerImageModal = document.getElementById("modal-container-image");
      const codeImage = document.getElementById("code-text-related")
      const imageModal = document.getElementById("image-modal");
      const linkImage = document.getElementById("link-text-related");
      const altImage = document.getElementById("alt-text-related");
      const imageSelectedC = document.getElementById(IdImage);

      containerImageModal.style.display = "block"
      imageModal.src = filesAdd[id].replaceBody
      codeImage.value = IdImage
      altImage.value = (imageSelectedC.alt === "#") ? "" : imageSelectedC.alt
      linkImage.value = (imageSelectedC.parentElement.href === "http://localhost:3001/blog-user#") 
        ? ""
        : imageSelectedC.parentElement.href
      
      onChangeInformation(containerInput)
    }catch(er){
      console.log(er)
    }
    
  }
  
  const cancelModalImage = () => {
    try{
      const containerImageModal = document.getElementById("modal-container-image");
      const linkImage = document.getElementById("link-text-related");
      const altImage = document.getElementById("alt-text-related");

      containerImageModal.style.display = "none"
      altImage.value = ''
      linkImage.value = ''
    }catch(er){
      console.log(er)
    }
    
  }

  const deleteImage = (id) => {
    try {
      const containerInput = document.getElementById(`container-blog-input-${idClock}`);
      const containerImageSelect = document.getElementsByClassName(id);

      containerImageSelect[0].remove()
      delete filesAdd[id]
      onChangeInformation(containerInput)
    } catch (er) {
      console.log(er)
    }
  };

  const addChangesButton = () => {
    try {
      const containerInput = document.getElementById(`container-blog-input-${idClock}`);
      const containerButtonModal = document.getElementById(`modal-container-button-${idClock}`);
      const codeButton = document.getElementById(`code-text-related-btn-${idClock}`)
      const buttonSelected = document.getElementById(codeButton.value);
      
      const linkToRedirect = document.getElementById(`link-to-redirect-${idClock}`);
      const textButton = document.getElementById(`text-button-${idClock}`);
      const colorButton = document.getElementById(`color-button-${idClock}`);
      const colorTextButton = document.getElementById(`color-text-button-${idClock}`);
      // const containerForm = document.getElementById("embed-form");

      const formId = document.getElementById(`form-id-${idClock}`);
      const resource = document.getElementById(`resource-modal-${idClock}`);

      if(selectionOfButton === "linkredirect"){
        const parentElement = buttonSelected.parentElement.parentElement;
        parentElement.dataset.type = selectionOfButton

        if(buttonSelected){
          buttonSelected.textContent = (textButton.value === "" || textButton.value === " ") ? "Button" : textButton.value
          buttonSelected.style.background = colorButton.value;
          buttonSelected.style.color = colorTextButton.value;
        }
        
  
        if (linkToRedirect.value.length > 0 && buttonSelected && buttonSelected.parentNode.tagName === 'A') {
          const parentAnchor = buttonSelected.parentNode;
          parentAnchor.href = linkToRedirect.value;
          parentAnchor.target = "_blank";
        }
        containerButtonModal.style.display = "none"
      }
      if(selectionOfButton === "resource"){
        if (resource && resource.value?.trim()?.length > 0 && buttonSelected) {
          const parentElement = buttonSelected.parentElement.parentElement;
          parentElement.dataset.idResource = resource.value;
          parentElement.dataset.type = selectionOfButton;
        }
        
        if(buttonSelected){
          buttonSelected.textContent = (textButton.value === "" || textButton.value === " ") ? "Button" : textButton.value
          buttonSelected.style.background = colorButton.value;
          buttonSelected.style.color = colorTextButton.value;
          const parentAnchor = buttonSelected.parentNode;
          parentAnchor.href = '#'; 
        }
        containerButtonModal.style.display = "none"
      }

      if(selectionOfButton === "hubspot"){
        if(buttonSelected){
          buttonSelected.textContent = (textButton.value === "" || textButton.value === " ") ? "Button" : textButton.value
          buttonSelected.style.background = colorButton.value;
          buttonSelected.style.color = colorTextButton.value;
          const parentAnchor = buttonSelected.parentNode;
          parentAnchor.href = '#'; 
        }
        if (formId && formId.value?.trim()?.length > 0 && buttonSelected) {
          const parentElement = buttonSelected.parentElement.parentElement;
          parentElement.dataset.formId = formId.value;
          parentElement.dataset.type = selectionOfButton;
        }
        
        containerButtonModal.style.display = "none"
      }
      onChangeInformation(containerInput)
    } catch (er) {
      console.log(er)
    }
  };

  const editButton = (IdButton) => {
    // try {
      function rgbToHex(rgb) {
        // Convertir el color RGB en formato "rgb(r, g, b)" a un array de valores numéricos
        const rgbArray = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        if (!rgbArray) return rgb; // Devolver el valor original si no se puede convertir
        // Convertir los valores numéricos a hexadecimal y formatearlos
        function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        }
        return "#" + hex(rgbArray[1]) + hex(rgbArray[2]) + hex(rgbArray[3]);
      }

      const containerInput = document.getElementById(`container-blog-input-${idClock}`);
      const containerButtonModal = document.getElementById(`modal-container-button-${idClock}`);
      const codeButton = document.getElementById(`code-text-related-btn-${idClock}`)
      const buttonSelected = document.getElementById(IdButton);

      const estilosBoton = window.getComputedStyle(buttonSelected);

      const colorButton = document.getElementById(`color-button-${idClock}`);
      const colorTextButton = document.getElementById(`color-text-button-${idClock}`);

      colorButton.value = rgbToHex(estilosBoton.backgroundColor);
      colorTextButton.value = rgbToHex(estilosBoton.color);

      const linkToRedirect = document.getElementById(`link-to-redirect-${idClock}`);
      const textButton = document.getElementById(`text-button-${idClock}`);
      const formId = document.getElementById(`form-id-${idClock}`);
      const resource = document.getElementById(`resource-modal-${idClock}`);

      setSelectionOfButton(buttonSelected.parentElement.parentElement.dataset.type)

      formId.value = buttonSelected.parentElement.parentElement.dataset.formId
      resource.value = buttonSelected.parentElement.parentElement.dataset.idResource

      const radio = containerButtonModal.querySelector(`input[name="typeData"][value="${buttonSelected.parentElement.parentElement.dataset.type}"]`);
      if (radio) {radio.checked = true}

      containerButtonModal.style.display = "block"
      codeButton.value = IdButton
      linkToRedirect.value = buttonSelected.parentElement.href
      textButton.value = buttonSelected.textContent
      onChangeInformation(containerInput);
    // } catch (er) {
    //   console.log(er)
    // }
  };
  
  const cancelModalButton = () => {
    try {
      const containerButtonModal = document.getElementById(`modal-container-button-${idClock}`);
      const linkToRedirect = document.getElementById(`link-to-redirect-${idClock}`);
      const textButton = document.getElementById(`text-button-${idClock}`);
      const formId = document.getElementById(`form-id-${idClock}`);
      const resource = document.getElementById(`resource-${idClock}`);
      const colorButton = document.getElementById(`color-button-${idClock}`);
      const colorTextButton = document.getElementById(`color-text-button-${idClock}`);

      containerButtonModal.style.display = "none"
      linkToRedirect.value = ''
      textButton.value = ''
      colorButton.value = ''
      colorTextButton.value = ''
      formId.value = ''
      resource.value = ''
    } catch (er) {
      console.log(er)
    }
  };

  const deleteButton = (id) => {
    try {
      const containerInput = document.getElementById(`container-blog-input-${idClock}`);
      const containerButtonSelected = document.getElementById(id);
      if(containerButtonSelected.parentElement.parentElement.className === 'button-container-input'){
        containerButtonSelected.parentElement.parentElement.remove();
        onChangeInformation(containerInput)
      }
    } catch (er) {
      console.log(er)
    }
  };
  
  const deleteInsert = (id) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const containerInsertSelect = document.getElementById(id);

      containerInsertSelect.remove()
      onChangeInformation(containerInput)
    }catch(er){
      console.log(er)
    }
    
  }

  const setEventActionsInsert = (Id1,IdContainerInsert,IdSizeRangeVideo) => {
    try{
      const container1 = document.getElementById(Id1);
      const container2 = document.getElementById(IdSizeRangeVideo);
      const containerInsert = document.getElementById(IdContainerInsert);


      if (container1 && containerInsert) {

        const containerInput   = document.getElementById(`container-blog-input-${idClock}`); 

        const newP = document.createElement("p");
        newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
        newP.setAttribute("data-placeholder", "Write here");
        containerInput.insertBefore(newP,containerInsert.nextSibling)

        container1.addEventListener("click", () => deleteInsert(IdContainerInsert));
        container2.addEventListener("change", () => setVideoSize(IdSizeRangeVideo));

      } else {
        setTimeout(() => {
          setEventActionsInsert(Id1,IdContainerInsert,IdSizeRangeVideo);
        }, 200);
      }
    }catch(er){
      console.log(er)
    }
  };

  const createInsert = () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(rangeForLink);

      const IdContainerInsert = moment().format("@YYYYMMDDhhmmssSSS-container-video@");
      const Id1 = moment().format("YYYYMMDDhhmmssSSS-1");
      const IdSizeRangeVideo = moment().format("YYYYMMDDhhmmssSSS-size-range-video");
      const regexYoutube = /(youtube\.com)/;
      const regexVimeo = /(vimeo\.com)/;

      let linkFormated = ""

      var div = document.createElement('div');
      div.innerHTML = Link;

      if(div.children[0]){

        if(div.children[0].tagName === 'IFRAME'){
          let iframe = div.querySelector('iframe');
          let enlace = iframe.getAttribute('src');
          linkFormated = enlace;
        }
       

      }else{

        if(regexYoutube.test(Link)){
          const regexYoutubeVerify = /^https:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]+(?:\?si=[a-zA-Z0-9_-]+)?$/
          if(regexYoutubeVerify.test(Link)){
            linkFormated = Link
          }else{
            const code = Link.match(/watch\?v=([^&]+)/)
            linkFormated = `https://www.youtube.com/embed/${code[1]}`
          }
        }
        if(regexVimeo.test(Link)){
          const code = Link.match(/\d+/g);
          linkFormated = `https://player.vimeo.com/video/${code[1]}`
        }

      }

      const brs = containerInput.querySelectorAll('div > br');
      seleccion = refactoringLinkError(brs)

      let elemento = (seleccion.focusNode.parentElement.id === `container-blog-input-${idClock}`)
        ? seleccion.focusNode
        : (seleccion.focusNode.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
          ? seleccion.focusNode.parentElement
          : (seleccion.focusNode.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
            ? seleccion.focusNode.parentElement.parentElement
            : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
              ? seleccion.focusNode.parentElement.parentElement.parentElement
              : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
                && seleccion.focusNode.parentElement.parentElement.parentElement.parentElement

      const newP = document.createElement("p");
      newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
      newP.setAttribute("data-placeholder", "Write here");
      containerInput.insertBefore(newP,elemento.nextSibling)
      
      newP.focus()
      let rangoFinish = document.createRange();
  
      rangoFinish.setStart(newP, 0);
      rangoFinish.collapse(true);

      seleccion.removeAllRanges();
      seleccion.addRange(rangoFinish);

      if(seleccion){
        if(seleccion.focusNode){
          if((elemento.textContent === '' || elemento.textContent === ' ') && (seleccion.focusNode.parentElement.tagName === "FIGURE" || seleccion.focusNode.parentElement.tagName === "FIGCAPTION")){
            elemento.remove()
          } 
        }
      }
      
      document.execCommand(
        "insertHTML",
        true,
        //format case html
        //<div class="container-insert" id="${IdContainerInsert}" style="width:100%; height:auto;">
        //  <div style="position: relative; padding-bottom: 60%; height: 0; overflow: hidden;">
        //    <div class="container-image-buttons">
        //      <div class="container-image-buttons-inter">
        //        <button type="button" aria-label="Borrar imagen" id="${Id1}">
        //          <li-icon aria-hidden="true" type="maximize" size="small">
        //            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false">
        //              <path d="M8 6.59L6.59 8 3 4.41V7H1V1h6v2H4.41zM13 9v2.59L9.41 8 8 9.41 11.59 13H9v2h6V9z"></path>
        //            </svg>
        //          </li-icon>
        //        </button>
        //        <input id="${IdSizeRangeVideo}" class="input-range" title="Video Resize" type='range' style="width: 75%; margin-top:10px; accent-color: #fe5621; margin-left: 24px;" ></input>
        //      </div>
        //    </div>
        //    <iframe src="" style="position: absolute; top:0; left: 0; width: 100%; height: 100%;" title="Hacking Hr Video Player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen>
        //    </iframe>
        //  </div>
        //</div>
        //<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" contenteditable="true" data-placeholder="Write here"></p>
        `<div class="container-insert" id="${IdContainerInsert}" style="width:100%; height:auto;"><div style="position: relative; padding-bottom: 60%; height: 0; overflow: hidden;"><div class="container-image-buttons"><div class="container-image-buttons-inter"><button type="button" aria-label="Borrar imagen" id="${Id1}"><li-icon aria-hidden="true" type="cancel" size="small"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false"><path d="M14 3.41L9.41 8 14 12.59 12.59 14 8 9.41 3.41 14 2 12.59 6.59 8 2 3.41 3.41 2 8 6.59 12.59 2z"></path></svg></li-icon></button><input id="${IdSizeRangeVideo}" class="input-range" title="Video Resize" type='range' style="width: 75%; margin-top:10px; accent-color: #fe5621; margin-left: 24px;" ></input></div></div><iframe src="${linkFormated}" style="position: absolute; top:0; left: 0; width: 100%; height: 100%;" title="Hacking Hr Video Player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`
      );

      newP.remove()      

      setTextModal("")
      setEventActionsInsert(Id1,IdContainerInsert,IdSizeRangeVideo);
      onChangeInformation(containerInput)
    }catch(er){
      console.log(er)
    }
  }

  const createInsertHtml = () => {
    try{

      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(rangeForLink);

      const brs = containerInput.querySelectorAll('div > br');
      seleccion = refactoringLinkError(brs)

      let elemento = (seleccion.focusNode.parentElement.id === `container-blog-input-${idClock}`)
        ? seleccion.focusNode
        : (seleccion.focusNode.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
          ? seleccion.focusNode.parentElement
          : (seleccion.focusNode.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
            ? seleccion.focusNode.parentElement.parentElement
            : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
              ? seleccion.focusNode.parentElement.parentElement.parentElement
              : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`) 
                && seleccion.focusNode.parentElement.parentElement.parentElement.parentElement

      const newP = document.createElement("p");
      newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
      newP.setAttribute("data-placeholder", "Write here");
      containerInput.insertBefore(newP,elemento.nextSibling)
      
      newP.focus()
      let rangoFinish = document.createRange();
  
      rangoFinish.setStart(newP, 0);
      rangoFinish.collapse(true);

      seleccion.removeAllRanges();
      seleccion.addRange(rangoFinish);

      if(seleccion){
        if(seleccion.focusNode){
          if((elemento.textContent === '' || elemento.textContent === ' ') && (seleccion.focusNode.parentElement.tagName === "FIGURE" || seleccion.focusNode.parentElement.tagName === "FIGCAPTION")){
            elemento.remove()
          } 
        }
      }

      document.execCommand(
        "insertHTML",
        true,
        `${Link}`
      );     

      setTextModal("")
      setBulCaseInput(false)
    }catch(er){
      console.log(er)
    }
  }

  const setEventActionsImage = (Id1,Id2,Id3,IdExpand,IdContainerImage,IdImage,IdSizeRange) => {
    try{
      const buttonImage = document.getElementById(`button-image-${idClock}`);

      const container1 = document.getElementById(Id1);
      const container2 = document.getElementById(Id2);
      const container3 = document.getElementById(Id3);
      const container4 = document.getElementById(IdSizeRange);
      buttonImage.value = "";

      if (container1 && container2 && container3) {
        container1.addEventListener("click", () => expandImage(IdExpand));
        container2.addEventListener("click", () => editImage(IdContainerImage,IdImage));
        container3.addEventListener("click", () => deleteImage(IdContainerImage));
        container4.addEventListener("change", () => setImageSize(IdSizeRange));
      } else {
        setTimeout(() => {
          setEventActionsImage(Id1,Id2,Id3,IdExpand,IdContainerImage,IdImage, IdSizeRange);
        }, 200);
      }
    }catch(er){
      console.log(er)
    }
  };

  const generateImage = async (inputFile,containerInput) => {
    try {
      if (clock.current) {
        clearTimeout(clock.current)
      };

      clock.current = setTimeout(async () => {
        const IdContainerImage = moment().format("@YYYYMMDDhhmmssSSS-container-image@");
        const Id1 = moment().format("YYYYMMDDhhmmssSSS-1");
        const Id2 = moment().format("YYYYMMDDhhmmssSSS-2");
        const Id3 = moment().format("YYYYMMDDhhmmssSSS-3");
        const IdSizeRange = moment().format("YYYYMMDDhhmmssSSS-size-range");
        const IdImage = moment().format("YYYYMMDDhhmmssSSS-image");
        const IdExpand = moment().format("YYYYMMDDhhmmssSSS-expand");

        if (inputFile.files[0]) {
          const file = inputFile.files[0]
          const base64FormatFile = await getBase64(inputFile.files[0])

          const fileBlob = new Blob([file], { type: file.type });

          const urlStatic = URL.createObjectURL(fileBlob)

          filesAdd = {
            ...filesAdd,
            [IdContainerImage]: {
              data: base64FormatFile,
              replaceBody: urlStatic
            }
          }
          
          const brs = containerInput.querySelectorAll('div > br');
          seleccion = refactoringLinkError(brs)

          let elemento = (seleccion.focusNode.parentElement.id === `container-blog-input-${idClock}`)
            ? seleccion.focusNode
            : (seleccion.focusNode.parentElement.parentElement.id === `container-blog-input-${idClock}`)
              ? seleccion.focusNode.parentElement
              : (seleccion.focusNode.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`)
                ? seleccion.focusNode.parentElement.parentElement
                : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`)
                  ? seleccion.focusNode.parentElement.parentElement.parentElement
                  : (seleccion.focusNode.parentElement.parentElement.parentElement.parentElement.parentElement.id === `container-blog-input-${idClock}`)
                  && seleccion.focusNode.parentElement.parentElement.parentElement.parentElement

          const newP = document.createElement("p");
          newP.setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
          newP.setAttribute("data-placeholder", "Write here");
          containerInput.insertBefore(newP, elemento.nextSibling)
        
          newP.focus()
          let rangoFinish = document.createRange();
    
          rangoFinish.setStart(newP, 0);
          rangoFinish.collapse(true);

          seleccion.removeAllRanges();
          seleccion.addRange(rangoFinish);

          if (seleccion) {
            if (seleccion.focusNode) {
              if ((elemento.textContent === '' || elemento.textContent === ' ') && (seleccion.focusNode.parentElement.tagName === "FIGURE" || seleccion.focusNode.parentElement.tagName === "FIGCAPTION")) {
                elemento.remove()
              }
            }
          
          }

          document.execCommand(
            "insertHTML",
            true,
            `<figure class="container-image ${IdContainerImage}" style="margin:10px 0px; display: flex; flex-direction: column; width: 100%; justify-content: center; align-items:center; height: auto;"><div class="container-image-expand" contenteditable="false" style="width: ${(containerInput.clientWidth / 2) - 40}px; display: flex; justify-content: center; align-items: center; margin: 0 auto; overflow: hidden; position: relative; transition: all 0.5s ease-in-out;" id="${IdExpand}"><div class="container-image-buttons"><div class="container-image-buttons-inter"><button type="button" aria-label="Cambiar tamaño de la imagen" id="${Id1}"><li-icon aria-hidden="true" type="maximize" size="small"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false"><path d="M8 6.59L6.59 8 3 4.41V7H1V1h6v2H4.41zM13 9v2.59L9.41 8 8 9.41 11.59 13H9v2h6V9z"></path></svg></li-icon></button><button type="button" aria-label="Editar imagen" id="${Id2}"><li-icon aria-hidden="true" type="edit" size="small"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false"><path d="M14.13 1.86a3 3 0 00-4.17 0l-7 7L1 15l6.19-2 6.94-7a3 3 0 000-4.16zm-8.36 9.71l-1.35-1.34L9.64 5 11 6.35z"></path></svg></li-icon></button><button type="button" aria-label="Borrar imagen" id="${Id3}"><li-icon aria-hidden="true" type="cancel" size="small"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false"><path d="M14 3.41L9.41 8 14 12.59 12.59 14 8 9.41 3.41 14 2 12.59 6.59 8 2 3.41 3.41 2 8 6.59 12.59 2z"></path></svg></li-icon></button><input id="${IdSizeRange}" class="input-range" title="Image Size" type='range' style="width: 100%; margin-top:10px; accent-color: #fe5621; margin-left: 24px;" ></input></div></div><a style="width: 100%; height: auto; padding: 0px; margin: 0px;" href="#"><img id="${IdImage}" src="${urlStatic}" alt="#" style="filter: none; height: auto; width: 100%;" /></a></div><figcaption style="color: rgba(0, 0, 0, 0.6); font-size: 14px; margin-top: 2px; line-height: 12px; text-align: center; height: 20px; width: 100%;" tabxindex="0" data-placeholder="Write here"></figcaption></figure><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" contenteditable="true" data-placeholder="Write here"></p>`
          );

          newP.remove()

          const children = containerInput?.children;
          for (let i = 0; i < children.length; i++) {
            if (children[i].tagName === "P") {
              if (children[i].children[0]) {
                if (children[i].children[0].tagName === "P") {
                  children[i].children[0].remove()
                }
              }
            
            }
          }
        }

        setEventActionsImage(Id1, Id2, Id3, IdExpand, IdContainerImage, IdImage, IdSizeRange);
      }, 200);
    }catch(er){
      console.log(er)
    }
    
  };
  
  const formatErrors = async () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const children = containerInput.querySelectorAll('*');
      for (let i = 0; i < children.length; i++) {
        if(['P'].includes(children[i].tagName)){
          let estilo = window.getComputedStyle(children[i]);

          let color = estilo.getPropertyValue('color');
          let fontSize = estilo.getPropertyValue('font-size');
          let lineHeight = estilo.getPropertyValue('line-height');
          let marginTop = estilo.getPropertyValue('margin-top');
          let marginBottom = estilo.getPropertyValue('margin-bottom');

          if(color === 'rgba(0, 0, 0, 0.9)' && fontSize === '14px' && lineHeight === '16px' && marginTop === '20px' && marginBottom === '20px'){
            children[i].setAttribute("style", "color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;");
          }

          if(children[i].textContent === '' || children[i].textContent === ' '){
            children[i].remove()
          }
        }
      }
    }catch(er){
      console.log(er)
    }
    
  }

  const mantainAllTagsCases = (father,textFixed,child) => {
    try{

      if(father.tagName === 'UL'){
        let textFixUl = textFixed.slice(0, -5);
        textFixed = textFixed.endsWith('</ul>')
          ? `${textFixUl}${child.outerHTML}</ul>`
          : `${textFixed}<ul>${child.outerHTML}</ul>`
      }

      if(father.tagName === 'OL'){
        let textFixOl = textFixed.slice(0, -5);
        textFixed = textFixed.endsWith('</ol>')
          ? `${textFixOl}${child.outerHTML}</ol>`
          : `${textFixed}<ol>${child.outerHTML}</ol>`
      }

      if(father.tagName === 'BLOCKQUOTE'){
        let textFixBlockquote = textFixed.slice(0, -13);
        textFixed = textFixed.endsWith('</blockquote>')
          ? `${textFixBlockquote}${child.outerHTML}</blockquote>`
          : `${textFixed}<blockquote class="blockquote-style" style="border-left: 2px solid rgb(86, 104, 122); padding-left: 5px; text-align: left; color: rgb(86, 104, 122);">${child.outerHTML}</blockquote>`
      }

      if(father.tagName === 'PRE'){
        let textFixPre = textFixed.slice(0, -6);
        textFixed = textFixed.endsWith('</pre>')
          ? `${textFixPre}${child.outerHTML}</pre>`
          : `${textFixed}<pre class="code-style" style="white-space: pre-wrap; color: #fff; font-size: 16px; line-height: 16px; background: #293138; border-radius: 15px; display: block; white-space: pre; overflow-x: auto;">${child.outerHTML}</pre>`
      }

      return textFixed
    }catch(er){
      console.log(er)
    }
  }

  const deleteUl = () => {
    try{

      const selection = window.getSelection();
      const selectedLi = [];

      for (let i = 0; i < selection.rangeCount; i++) {
          const range = selection.getRangeAt(i);
          const container = range.commonAncestorContainer;
          let containerFix = container.tagName === 'UL'
            ? container
            : container.parentElement.tagName === 'LI'
              ? container.parentElement
              : container.parentElement.parentElement.tagName === 'LI'
                ? container.parentElement.parentElement
                : container.parentElement.parentElement.parentElement.tagName === 'LI'
                  ? container.parentElement.parentElement.parentElement 
                  : container.parentElement.parentElement.parentElement.parentElement.tagName === 'LI'
                    ? container.parentElement.parentElement.parentElement.parentElement
                    : container.parentElement.parentElement.parentElement.parentElement.parentElement.tagName === 'LI'
                      ? container.parentElement.parentElement.parentElement.parentElement.parentElement
                      : container

          if (containerFix.nodeType === Node.ELEMENT_NODE) {
            if(containerFix.tagName !== 'LI'){
              const liElements = containerFix.getElementsByTagName('li');
              for (const li of liElements) {
                if (selection.containsNode(li, true)) {
                  if(li.getElementsByTagName('p')[0]){
                    selectedLi.push(li.getElementsByTagName('p')[0]);
                  }
                  if(li.getElementsByTagName('h2')[0]){
                    selectedLi.push(li.getElementsByTagName('h2')[0]);
                  }
                  if(li.getElementsByTagName('h3')[0]){
                    selectedLi.push(li.getElementsByTagName('h3')[0]);
                  }
                  if(li.getElementsByTagName('h4')[0]){
                    selectedLi.push(li.getElementsByTagName('h4')[0]);
                  }
                  if(li.getElementsByTagName('code')[0]){
                    selectedLi.push(li.getElementsByTagName('code')[0]);
                  } 
                }
              }
            }else{
              if(containerFix.getElementsByTagName('p')[0]){
                selectedLi.push(containerFix.getElementsByTagName('p')[0]);
              }
              if(containerFix.getElementsByTagName('h2')[0]){
                selectedLi.push(containerFix.getElementsByTagName('h2')[0]);
              }
              if(containerFix.getElementsByTagName('h3')[0]){
                selectedLi.push(containerFix.getElementsByTagName('h3')[0]);
              }
              if(containerFix.getElementsByTagName('h4')[0]){
                selectedLi.push(containerFix.getElementsByTagName('h4')[0]);
              }
              if(containerFix.getElementsByTagName('code')[0]){
                selectedLi.push(containerFix.getElementsByTagName('code')[0]);
              } 
            }
            
          }
      }

      function findParent(element,type) {
        let parent = element.closest(type);
        let position = parent ? Array.from(parent.querySelectorAll('p')).indexOf(element) : null;
        return parent ? { parent, position } : { parent: null, position: null };
      }

      const ulLiMap = new Map();

      selectedLi.forEach(li => {
        const {parent,position} = findParent(li,'ul');

        if (parent) {
          if (!ulLiMap.has(parent)) { ulLiMap.set(parent, []); }
          ulLiMap.get(parent).push({ son: li, position });
        }
      })

      const UlFixed = Array.from(ulLiMap.entries()).map(e => ({
        father: e[0],
        children: e[1]
      }))

      UlFixed.forEach(item => {
        const fragmento = document.createDocumentFragment();
        const newDiv = document.createElement("div");
        const { father, children } = item;
        const childs = father.children
        let textFixed = ``

        for(let i = 0; i < childs.length; i++){
          if(children.map(a => a.son).indexOf(childs[i].getElementsByTagName('p')[0]) !== -1){
            textFixed = `${textFixed}${childs[i].getElementsByTagName('p')[0].outerHTML}`
          }else{
            let textFixUl = textFixed.slice(0, -5);
            textFixed = textFixed.endsWith('</ul>')
              ? `${textFixUl}${childs[i].outerHTML}</ul>`
              : `${textFixed}<ul>${childs[i].outerHTML}</ul>`
          }
        }

        newDiv.innerHTML = textFixed
        
        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }
        
        if(father.parentElement){
          father.replaceWith(fragmento)
        }

      })

    }catch(er){
      console.log(er)
    }
  }

  const createUl = (container) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
        : (range.startContainer instanceof Element) && range.startContainer.tagName === "P"
          ? range.startContainer
          : range.startContainer.parentNode.tagName === "P"
            ? range.startContainer.parentNode
            : range.startContainer.parentNode.parentNode.tagName === "P"
              ? range.startContainer.parentNode.parentNode
              : range.startContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.startContainer.parentNode.parentNode.parentNode 
                : range.startContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.startContainer.parentNode.parentNode.parentNode.parentNode
                  : range.startContainer.parentNode
        const endSon = (bulUl || bulCode || bulBlockquote || bulOl)
          ? (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode
          : (range.endContainer instanceof Element) && range.endContainer.tagName === "P"
            ? range.endContainer
            : range.endContainer.parentNode.tagName === "P"
              ? range.endContainer.parentNode
              : range.endContainer.parentNode.parentNode.tagName === "P"
                ? range.endContainer.parentNode.parentNode
                : range.endContainer.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.endContainer.parentNode.parentNode.parentNode 
                  : range.endContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                    ? range.endContainer.parentNode.parentNode.parentNode.parentNode
                    : range.endContainer.parentNode

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){
        if(bulUl){

          deleteUl()
          formatErrors()
          onChangeInformation(containerInput)

        }else{

          const groupedElements = agroupInformationSelectForTheUser(container)
          const newDiv = document.createElement("div");
          const fragmento = document.createDocumentFragment();
          
          groupedElements.forEach((item,index) => {
            
            const { father, children } = item;
            const childs = father.children
            let textFixed = ``
    
            if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

              textFixed = newDiv.innerHTML.endsWith('</ul>')
              ? `<li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${father.innerHTML}</p></li></ul>`
              : `<ul><li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${father.innerHTML}</p></li></ul>`
          
              newDiv.innerHTML = `${(newDiv.innerHTML.endsWith('</ul>') ? newDiv.innerHTML.slice(0, -5) : newDiv.innerHTML )}${textFixed}`
            
            }else{
              let bulWithoutEnd = false

              for(let i = 0; i < childs.length; i++){
                let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
                let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
                let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
                let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
                let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
                
                if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                  let itemSelected;
                  if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                  if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH3) !== -1){itemSelected = caseChildH3.innerHTML}; 
                  if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};   

                  let textFixUl = textFixed.slice(0, -5);
                  bulWithoutEnd = (newDiv.innerHTML.endsWith('</ul>') && textFixed === ``) ? true : false
                  textFixed = (textFixed.endsWith('</ul>') || (newDiv.innerHTML.endsWith('</ul>') && textFixed === ``))
                    ? `${textFixUl}<li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${itemSelected}</p></li></ul>`
                    : `${textFixed}<ul><li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${itemSelected}</p></li></ul>`

                }else{

                  textFixed = mantainAllTagsCases(father,textFixed,childs[i])

                }
              }

              newDiv.innerHTML = `${bulWithoutEnd ? newDiv.innerHTML.slice(0, -5) : newDiv.innerHTML}${textFixed}`

            }

            if(index !== 0){
              father.remove()
            }

          })

          for (const child of newDiv.children) {
            const clonedChild = child.cloneNode(true);
            fragmento.appendChild(clonedChild);
          }

          if(groupedElements[0].father.parentElement){
            groupedElements[0].father.replaceWith(fragmento)
          }

          formatErrors()
          onChangeInformation(containerInput)
        
        }
      }
    }catch(er){
      console.log(er)
    }
  }

  const deleteOl = () => {
    try{

      const selection = window.getSelection();
      const selectedLi = [];

      for (let i = 0; i < selection.rangeCount; i++) {
          const range = selection.getRangeAt(i);
          const container = range.commonAncestorContainer;
          let containerFix = container.tagName === 'OL'
            ? container
            : container.parentElement.tagName === 'LI'
              ? container.parentElement
              : container.parentElement.parentElement.tagName === 'LI'
                ? container.parentElement.parentElement
                : container.parentElement.parentElement.parentElement.tagName === 'LI'
                  ? container.parentElement.parentElement.parentElement 
                  : container.parentElement.parentElement.parentElement.parentElement.tagName === 'LI'
                    ? container.parentElement.parentElement.parentElement.parentElement
                    : container.parentElement.parentElement.parentElement.parentElement.parentElement.tagName === 'LI'
                      ? container.parentElement.parentElement.parentElement.parentElement.parentElement
                      : container

          if (containerFix.nodeType === Node.ELEMENT_NODE) {
            if(containerFix.tagName !== 'LI'){
              const liElements = containerFix.getElementsByTagName('li');
              for (const li of liElements) {
                if (selection.containsNode(li, true)) {
                  if(li.getElementsByTagName('p')[0]){
                    selectedLi.push(li.getElementsByTagName('p')[0]);
                  }
                  if(li.getElementsByTagName('h2')[0]){
                    selectedLi.push(li.getElementsByTagName('h2')[0]);
                  }
                  if(li.getElementsByTagName('h3')[0]){
                    selectedLi.push(li.getElementsByTagName('h3')[0]);
                  }
                  if(li.getElementsByTagName('h4')[0]){
                    selectedLi.push(li.getElementsByTagName('h4')[0]);
                  }
                  if(li.getElementsByTagName('code')[0]){
                    selectedLi.push(li.getElementsByTagName('code')[0]);
                  } 
                }
              }
            }else{
              if(containerFix.getElementsByTagName('p')[0]){
                selectedLi.push(containerFix.getElementsByTagName('p')[0]);
              }
              if(containerFix.getElementsByTagName('h2')[0]){
                selectedLi.push(containerFix.getElementsByTagName('h2')[0]);
              }
              if(containerFix.getElementsByTagName('h3')[0]){
                selectedLi.push(containerFix.getElementsByTagName('h3')[0]);
              }
              if(containerFix.getElementsByTagName('h4')[0]){
                selectedLi.push(containerFix.getElementsByTagName('h4')[0]);
              }
              if(containerFix.getElementsByTagName('code')[0]){
                selectedLi.push(containerFix.getElementsByTagName('code')[0]);
              } 
            }
            
          }
      }

      function findParent(element,type) {
        let parent = element.closest(type);
        let position = parent ? Array.from(parent.querySelectorAll('p')).indexOf(element) : null;
        return parent ? { parent, position } : { parent: null, position: null };
      }

      const olLiMap = new Map();

      selectedLi.forEach(li => {
        const {parent,position} = findParent(li,'ol');

        if (parent) {
          if (!olLiMap.has(parent)) { olLiMap.set(parent, []); }
          olLiMap.get(parent).push({ son: li, position });
        }
      })

      const OlFixed = Array.from(olLiMap.entries()).map(e => ({
        father: e[0],
        children: e[1]
      }))

      OlFixed.forEach(item => {
        const fragmento = document.createDocumentFragment();
        const newDiv = document.createElement("div");
        const { father, children } = item;
        const childs = father.children
        let textFixed = ``

        for(let i = 0; i < childs.length; i++){
          if(children.map(a => a.son).indexOf(childs[i].getElementsByTagName('p')[0]) !== -1){
            textFixed = `${textFixed}${childs[i].getElementsByTagName('p')[0].outerHTML}`
          }else{
            let textFixOl = textFixed.slice(0, -5);
            textFixed = textFixed.endsWith('</ol>')
              ? `${textFixOl}${childs[i].outerHTML}</ol>`
              : `${textFixed}<ol>${childs[i].outerHTML}</ol>`
          }
        }

        newDiv.innerHTML = textFixed
        
        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }
        
        if(father.parentElement){
          father.replaceWith(fragmento)
        }

      })

    }catch(er){
      console.log(er)
    }
  }

  const createOl = (container) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
        : (range.startContainer instanceof Element) && range.startContainer.tagName === "P"
          ? range.startContainer
          : range.startContainer.parentNode.tagName === "P"
            ? range.startContainer.parentNode
            : range.startContainer.parentNode.parentNode.tagName === "P"
              ? range.startContainer.parentNode.parentNode
              : range.startContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.startContainer.parentNode.parentNode.parentNode 
                : range.startContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.startContainer.parentNode.parentNode.parentNode.parentNode
                  : range.startContainer.parentNode
      const endSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode
        : (range.endContainer instanceof Element) && range.endContainer.tagName === "P"
          ? range.endContainer
          : range.endContainer.parentNode.tagName === "P"
            ? range.endContainer.parentNode
            : range.endContainer.parentNode.parentNode.tagName === "P"
              ? range.endContainer.parentNode.parentNode
              : range.endContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.endContainer.parentNode.parentNode.parentNode 
                : range.endContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.endContainer.parentNode.parentNode.parentNode.parentNode
                  : range.endContainer.parentNode

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){
        if(bulOl){

          deleteOl()
          formatErrors()
          onChangeInformation(containerInput)
  
        }else{
          
          const groupedElements = agroupInformationSelectForTheUser(container)
          const newDiv = document.createElement("div");
          const fragmento = document.createDocumentFragment();

          groupedElements.forEach((item,index) => {
            
            const { father, children } = item;
            const childs = father.children
            let textFixed = ``
    
            if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

              textFixed = newDiv.innerHTML.endsWith('</ol>')
              ? `<li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${father.innerHTML}</p></li></ol>`
              : `<ol><li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${father.innerHTML}</p></li></ol>`
          
              newDiv.innerHTML = `${(newDiv.innerHTML.endsWith('</ol>') ? newDiv.innerHTML.slice(0, -5) : newDiv.innerHTML )}${textFixed}`
            
            }else{
              let bulWithoutEnd = false

              for(let i = 0; i < childs.length; i++){
                let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
                let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
                let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
                let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
                let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
                
                if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                  let itemSelected;
                  if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                  if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH3) !== -1){itemSelected = caseChildH3.innerHTML};
                  if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};   

                  let textFixUl = textFixed.slice(0, -5);
                  bulWithoutEnd = (newDiv.innerHTML.endsWith('</ol>') && textFixed === ``) ? true : false
                  textFixed = (textFixed.endsWith('</ol>') || (newDiv.innerHTML.endsWith('</ol>') && textFixed === ``))
                    ? `${textFixUl}<li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${itemSelected}</p></li></ol>`
                    : `${textFixed}<ol><li><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${itemSelected}</p></li></ol>`

                }else{

                  textFixed = mantainAllTagsCases(father,textFixed,childs[i])

                }
              }

              newDiv.innerHTML = `${bulWithoutEnd ? newDiv.innerHTML.slice(0, -5) : newDiv.innerHTML}${textFixed}`

            }

            if(index !== 0){
              father.remove()
            }

          })

          for (const child of newDiv.children) {
            const clonedChild = child.cloneNode(true);
            fragmento.appendChild(clonedChild);
          }

          if(groupedElements[0].father.parentElement){
            groupedElements[0].father.replaceWith(fragmento)
          }

          formatErrors()
          onChangeInformation(containerInput)
        
        }      
      }
  
    }catch(er){
      console.log(er)
    }
  }

  const deleteBlockquote = () => {
    try{
     
      const selection = window.getSelection();
      const selectedBlock = [];

      for (let i = 0; i < selection.rangeCount; i++) {
          const range = selection.getRangeAt(i);
          const container = range.commonAncestorContainer;
          let containerFix = container.tagName === 'BLOCKQUOTE'
            ? container
            : container.parentElement.tagName === 'BLOCKQUOTE'
              ? container.parentElement
              : container.parentElement.parentElement.tagName === 'BLOCKQUOTE'
                ? container.parentElement.parentElement
                : container.parentElement.parentElement.parentElement.tagName === 'BLOCKQUOTE'
                  ? container.parentElement.parentElement.parentElement 
                  : container.parentElement.parentElement.parentElement.parentElement.tagName === 'BLOCKQUOTE'
                    ? container.parentElement.parentElement.parentElement.parentElement
                    : container.parentElement.parentElement.parentElement.parentElement.parentElement.tagName === 'BLOCKQUOTE'
                      ? container.parentElement.parentElement.parentElement.parentElement.parentElement
                      : container

          if (containerFix.nodeType === Node.ELEMENT_NODE) {
            if(containerFix.tagName !== 'P'){
              const pElements = containerFix.getElementsByTagName('p');
              for (const pT of pElements) {
                if (selection.containsNode(pT, true)) {
                    selectedBlock.push(pT);
                }
              }
            }
            
          }
      }

      function findParent(element,type) {
        let parent = element.closest(type);
        let position = parent ? Array.from(parent.querySelectorAll('p')).indexOf(element) : null;
        return parent ? { parent, position } : { parent: null, position: null };
      }

      const ulBlockMap = new Map();

      selectedBlock.forEach(p => {
        const {parent,position} = findParent(p,'blockquote');

        if (parent) {
          if (!ulBlockMap.has(parent)) { ulBlockMap.set(parent, []); }
          ulBlockMap.get(parent).push({ son: p, position });
        }
      })

      const BlockFixed = Array.from(ulBlockMap.entries()).map(e => ({
        father: e[0],
        children: e[1]
      }))

      BlockFixed.forEach(item => {
        const fragmento = document.createDocumentFragment();
        const newDiv = document.createElement("div");
        const { father, children } = item;
        const childs = father.children
        let textFixed = ``

        for(let i = 0; i < childs.length; i++){
          const child = childs[i].tagName === 'P' ? childs[i] : childs[i].getElementsByTagName('p')[0]
          if(children.map(a => a.son).indexOf(child) !== -1){
            textFixed = `${textFixed}${child.outerHTML}`
          }else{
            let textFixBlock = textFixed.slice(0, -5);
            textFixed = textFixed.endsWith('</blockquote>')
              ? `${textFixBlock}${childs[i].outerHTML}</blockquote>`
              : `${textFixed}<blockquote class="blockquote-style" style="border-left: 2px solid rgb(86, 104, 122); padding-left: 5px; text-align: left; color: rgb(86, 104, 122);">${childs[i].outerHTML}</blockquote>`
          }
        }

        newDiv.innerHTML = textFixed
        
        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }
        
        if(father.parentElement){
          father.replaceWith(fragmento)
        }

      })

    }catch(er){
      console.log(er)
    }
  }

  const createBlockquote = (container) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
        : (range.startContainer instanceof Element) && range.startContainer.tagName === "P"
          ? range.startContainer
          : range.startContainer.parentNode.tagName === "P"
            ? range.startContainer.parentNode
            : range.startContainer.parentNode.parentNode.tagName === "P"
              ? range.startContainer.parentNode.parentNode
              : range.startContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.startContainer.parentNode.parentNode.parentNode 
                : range.startContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.startContainer.parentNode.parentNode.parentNode.parentNode
                  : range.startContainer.parentNode
      const endSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
        : (range.startContainer instanceof Element) && range.startContainer.tagName === "P"
          ? range.startContainer
          : range.endContainer.parentNode.tagName === "P"
            ? range.endContainer.parentNode
            : range.endContainer.parentNode.parentNode.tagName === "P"
              ? range.endContainer.parentNode.parentNode
              : range.endContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.endContainer.parentNode.parentNode.parentNode 
                : range.endContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.endContainer.parentNode.parentNode.parentNode.parentNode
                  : range.endContainer.parentNode

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){
        if(bulBlockquote){

          deleteBlockquote()
          formatErrors()
          onChangeInformation(containerInput)

        }else{
          
          const groupedElements = agroupInformationSelectForTheUser(container)
          const newDiv = document.createElement("div");
          const fragmento = document.createDocumentFragment();

          groupedElements.forEach((item,index) => {
            
            const { father, children } = item;
            const childs = father.children
            let textFixed = ``
    
            if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

              textFixed = newDiv.innerHTML.endsWith('</blockquote>')
              ? `<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${father.innerHTML}</p></blockquote>`
              : `<blockquote class="blockquote-style" style="border-left: 2px solid rgb(86, 104, 122); padding-left: 5px; text-align: left; color: rgb(86, 104, 122);"><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${father.innerHTML}</p></blockquote>`
          
              newDiv.innerHTML = `${(newDiv.innerHTML.endsWith('</blockquote>') ? newDiv.innerHTML.slice(0, -13) : newDiv.innerHTML )}${textFixed}`
            
            }else{
              let bulWithoutEnd = false

              for(let i = 0; i < childs.length; i++){
                let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
                let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
                let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
                let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
                let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
                
                if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                  let itemSelected;
                  if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                  if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH3) !== -1){itemSelected = caseChildH3.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};  

                  let textFixUl = textFixed.slice(0, -13);
                  bulWithoutEnd = (newDiv.innerHTML.endsWith('</blockquote>') && textFixed === ``) ? true : false
                  textFixed = (textFixed.endsWith('</blockquote>') || (newDiv.innerHTML.endsWith('</blockquote>') && textFixed === ``))
                    ? `${textFixUl}<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${itemSelected}</p></blockquote>`
                    : `${textFixed}<blockquote class="blockquote-style" style="border-left: 2px solid rgb(86, 104, 122); padding-left: 5px; text-align: left; color: rgb(86, 104, 122);"><p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${itemSelected}</p></blockquote>`

                }else{

                  textFixed = mantainAllTagsCases(father,textFixed,childs[i])

                }
              }

              newDiv.innerHTML = `${bulWithoutEnd ? newDiv.innerHTML.slice(0, -13) : newDiv.innerHTML}${textFixed}`

            }

            if(index !== 0){
              father.remove()
            }

          })

          for (const child of newDiv.children) {
            const clonedChild = child.cloneNode(true);
            fragmento.appendChild(clonedChild);
          }

          if(groupedElements[0].father.parentElement){
            groupedElements[0].father.replaceWith(fragmento)
          }

          formatErrors()
          onChangeInformation(containerInput)

        }
      }

    }catch(er){
      console.log(er)
    } 
  }

  const deleteCode = () => {
    try{
      const selection = window.getSelection();
      const selectedCode = [];

      for (let i = 0; i < selection.rangeCount; i++) {
          const range = selection.getRangeAt(i);
          const container = range.commonAncestorContainer;
          let containerFix = container.tagName === 'PRE'
            ? container
            : container.parentElement.tagName === 'CODE'
              ? container.parentElement
              : container.parentElement.parentElement.tagName === 'CODE'
                ? container.parentElement.parentElement
                : container.parentElement.parentElement.parentElement.tagName === 'CODE'
                  ? container.parentElement.parentElement.parentElement 
                  : container.parentElement.parentElement.parentElement.parentElement.tagName === 'CODE'
                    ? container.parentElement.parentElement.parentElement.parentElement
                    : container.parentElement.parentElement.parentElement.parentElement.parentElement.tagName === 'CODE'
                      ? container.parentElement.parentElement.parentElement.parentElement.parentElement
                      : container

          if (containerFix.nodeType === Node.ELEMENT_NODE) {
            if(containerFix.tagName !== 'CODE'){
              const codeElements = containerFix.getElementsByTagName('code');
              for (const code of codeElements) {
                const codeSelect = code.tagName === 'CODE' ? code : code.getElementsByTagName('code')[0]
                if (selection.containsNode(code, true)) {
                    selectedCode.push(codeSelect);
                }
              }
            }else{
              const codeSelect = containerFix.tagName === 'CODE' ? containerFix : containerFix.getElementsByTagName('code')[0]
              selectedCode.push(codeSelect);
            }
            
          }
      }

      function findParent(element,type) {
        let parent = element.closest(type);
        let position = parent ? Array.from(parent.querySelectorAll('code')).indexOf(element) : null;
        return parent ? { parent, position } : { parent: null, position: null };
      }

      const ulCodeMap = new Map();

      selectedCode.forEach(code => {
        const {parent,position} = findParent(code,'pre');

        if (parent) {
          if (!ulCodeMap.has(parent)) { ulCodeMap.set(parent, []); }
          ulCodeMap.get(parent).push({ son: code, position });
        }
      })

      const CodeFixed = Array.from(ulCodeMap.entries()).map(e => ({
        father: e[0],
        children: e[1]
      }))

      CodeFixed.forEach(item => {
        const fragmento = document.createDocumentFragment();
        const newDiv = document.createElement("div");
        const { father } = item;
        const childs = father.children
        let textFixed = ``

        for(let i = 0; i < childs.length; i++){
          const codeSelect = childs[i].tagName === 'CODE' ? childs[i] : childs[i].getElementsByTagName('code')[0]

          textFixed = `${textFixed}<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${codeSelect.innerHTML}</p>`

        }

        newDiv.innerHTML = textFixed
        
        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }
        
        if(father.parentElement){
          father.replaceWith(fragmento)
        }

      })

    }catch(er){
      console.log(er)
    }
  }

  const createCode = (container) => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
        : (range.startContainer instanceof Element) && range.startContainer.tagName === "P"
          ? range.startContainer
          : range.startContainer.parentNode.tagName === "P"
            ? range.startContainer.parentNode
            : range.startContainer.parentNode.parentNode.tagName === "P"
              ? range.startContainer.parentNode.parentNode
              : range.startContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.startContainer.parentNode.parentNode.parentNode 
                : range.startContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.startContainer.parentNode.parentNode.parentNode.parentNode
                  : range.startContainer.parentNode
      const endSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode
        : (range.endContainer instanceof Element) && range.endContainer.tagName === "P"
          ? range.endContainer
          : range.endContainer.parentNode.tagName === "P"
            ? range.endContainer.parentNode
            : range.endContainer.parentNode.parentNode.tagName === "P"
              ? range.endContainer.parentNode.parentNode
              : range.endContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.endContainer.parentNode.parentNode.parentNode 
                : range.endContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.endContainer.parentNode.parentNode.parentNode.parentNode
                  : range.endContainer.parentNode

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){
        if(bulCode){

          deleteCode()
          formatErrors()
          onChangeInformation(containerInput)
  
        }else{
          
          const groupedElements = agroupInformationSelectForTheUser(container)
          const newDiv = document.createElement("div");
          const fragmento = document.createDocumentFragment();
          
          groupedElements.forEach((item,index) => {
            
            const { father, children } = item;
            const childs = father.children
            let textFixed = ``
    
            if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

              textFixed = newDiv.innerHTML.endsWith('</pre>')
              ? `<code>${father.innerHTML}</code></pre>`
              : `<pre class="code-style" style="white-space: pre-wrap; color: #fff; font-size: 16px; line-height: 16px; background: #293138; border-radius: 15px; display: block; white-space: pre; overflow-x: auto;"><code>${father.innerHTML}</code></pre>`
          
              newDiv.innerHTML = `${(newDiv.innerHTML.endsWith('</pre>') ? newDiv.innerHTML.slice(0, -6) : newDiv.innerHTML )}${textFixed}`
            
            }else{
              let bulWithoutEnd = false

              for(let i = 0; i < childs.length; i++){
                let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
                let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
                let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
                let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
                let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
                
                if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                  let itemSelected;
                  if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                  if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH3) !== -1){itemSelected = caseChildH3.innerHTML};   
                  if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};    

                  let textFixUl = textFixed.slice(0, -6);
                  bulWithoutEnd = (newDiv.innerHTML.endsWith('</pre>') && textFixed === ``) ? true : false
                  textFixed = (textFixed.endsWith('</pre>') || (newDiv.innerHTML.endsWith('</pre>') && textFixed === ``))
                    ? `${textFixUl}<code>${itemSelected}</code></pre>`
                    : `${textFixed}<pre class="code-style" style="white-space: pre-wrap; color: #fff; font-size: 16px; line-height: 16px; background: #293138; border-radius: 15px; display: block; white-space: pre; overflow-x: auto;"><code>${itemSelected}</code></pre>`
                }else{
                  textFixed = mantainAllTagsCases(father,textFixed,childs[i])
                }
              }

              newDiv.innerHTML = `${bulWithoutEnd ? newDiv.innerHTML.slice(0, -6) : newDiv.innerHTML}${textFixed}`

            }

            if(index !== 0){
              father.remove()
            }

          })

          for (const child of newDiv.children) {
            const clonedChild = child.cloneNode(true);
            fragmento.appendChild(clonedChild);
          }

          if(groupedElements[0].father.parentElement){
            groupedElements[0].father.replaceWith(fragmento)
          }

          formatErrors()
          onChangeInformation(containerInput)
        
        }      
      }

    }catch(er){
      console.log(er)
    }
  }

  const createParraf = () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode;
      const endSon =  (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode;

      console.log("Step 2")
      console.log(startSon, endSon, containerInput)
      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){

        const groupedElements = agroupInformationSelectForTheUser(containerInput)
        const newDiv = document.createElement("div");
        const fragmento = document.createDocumentFragment();

        console.log("Step 3")
        console.log(groupedElements,newDiv,fragmento)
        
        groupedElements.forEach((item,index) => {
          
          const { father, children } = item;
          const childs = father.children
          let textFixed = ``
  
          if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

            textFixed = `${textFixed}<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${father.innerHTML}</p>`
          
          }else{
            for(let i = 0; i < childs.length; i++){
              let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
              let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
              let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
              let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
              let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
              
              if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                let itemSelected;
                if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH3) !== -1){itemSelected = caseChildH3.innerHTML};
                if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};     

                textFixed = `${textFixed}<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here">${itemSelected}</p>`

              }else{
                textFixed = mantainAllTagsCases(father,textFixed,childs[i])
              }
            }
          }
          newDiv.innerHTML = `${newDiv.innerHTML}${textFixed}`

          if(index !== 0){
            father.remove()
          }
        })

        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }

        if(groupedElements[0].father.parentElement){
          groupedElements[0].father.replaceWith(fragmento)
        }

        formatErrors()
        onChangeInformation(containerInput)
      }
    }catch(er){
      console.log(er)
    }
  }

  const createH2 = () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode;
      const endSon =  (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode;

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){

        const groupedElements = agroupInformationSelectForTheUser(containerInput)
        const newDiv = document.createElement("div");
        const fragmento = document.createDocumentFragment();

        console.log("Step 3")
        console.log(groupedElements,newDiv,fragmento)

        groupedElements.forEach((item,index) => {
          
          const { father, children } = item;
          const childs = father.children
          let textFixed = ``
  
          if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

            textFixed = `${textFixed}<h2 style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:10px !important; margin-bottom:10px !important; ">${father.innerHTML}</h2>`
          
          }else{

            for(let i = 0; i < childs.length; i++){
              let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
              let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
              let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
              let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
              let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
              
              if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                let itemSelected;
                if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH3) !== -1){itemSelected = caseChildH3.innerHTML};
                if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};     

                textFixed = `${textFixed}<h2 style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:10px !important; margin-bottom:10px !important; ">${itemSelected}</h2>`

              }else{

                textFixed = mantainAllTagsCases(father,textFixed,childs[i])

              }
            }
          }

          newDiv.innerHTML = `${newDiv.innerHTML}${textFixed}`

          if(index !== 0){
            father.remove()
          }

        })

        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }

        if(groupedElements[0].father.parentElement){
          groupedElements[0].father.replaceWith(fragmento)
        }

        formatErrors()
        onChangeInformation(containerInput)

      }
    }catch(er){
      console.log(er)
    }
  }

  const createH3 = () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode;
      const endSon =  (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode;

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){

        const groupedElements = agroupInformationSelectForTheUser(containerInput)
        const newDiv = document.createElement("div");
        const fragmento = document.createDocumentFragment();

        groupedElements.forEach((item,index) => {
          
          const { father, children } = item;
          const childs = father.children
          let textFixed = ``
  
          if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

            textFixed = `${textFixed}<h3 style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:10px !important; margin-bottom:10px !important; ">${father.innerHTML}</h3>`
          
          }else{

            for(let i = 0; i < childs.length; i++){
              let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
              let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
              let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
              let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
              let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
              
              if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                let itemSelected;
                if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};     

                textFixed = `${textFixed}<h3 style"color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:10px !important; margin-bottom:10px !important; ">${itemSelected}</h3>`

              }else{

                textFixed = mantainAllTagsCases(father,textFixed,childs[i])

              }
            }

          }

          newDiv.innerHTML = `${newDiv.innerHTML}${textFixed}`

          if(index !== 0){
            father.remove()
          }

        })

        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }

        if(groupedElements[0].father.parentElement){
          groupedElements[0].father.replaceWith(fragmento)
        }

        formatErrors()
        onChangeInformation(containerInput)

      }
    }catch(er){
      console.log(er)
    }
  } 

  const createH4 = () => {
    try{
      const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (range.startContainer instanceof Element) ? range.startContainer : range.startContainer.parentNode
      const endSon =  (range.endContainer instanceof Element) ? range.endContainer : range.endContainer.parentNode

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){

        const groupedElements = agroupInformationSelectForTheUser(containerInput)
        const newDiv = document.createElement("div");
        const fragmento = document.createDocumentFragment();

        groupedElements.forEach((item,index) => {
          
          const { father, children } = item;
          const childs = father.children
          let textFixed = ``
  
          if(['DIV','P','CODE','H2','H3','H4'].includes(father.tagName)){

            textFixed = `${textFixed}<h4 style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:10px !important; margin-bottom:10px !important; ">${father.innerHTML}</h4>`
          
          }else{

            for(let i = 0; i < childs.length; i++){
              let caseChildP = (childs[i].tagName === 'P') ? childs[i] : childs[i].getElementsByTagName('p')[0];
              let caseChildCode = (childs[i].tagName === 'CODE') ? childs[i] : childs[i].getElementsByTagName('code')[0];
              let caseChildH2 = (childs[i].tagName === 'H2') ? childs[i] : childs[i].getElementsByTagName('h2')[0];
              let caseChildH3 = (childs[i].tagName === 'H3') ? childs[i] : childs[i].getElementsByTagName('h3')[0];
              let caseChildH4 = (childs[i].tagName === 'H4') ? childs[i] : childs[i].getElementsByTagName('h4')[0];
              
              if(children.map(a => a.son).indexOf(caseChildP) !== -1 || children.map(a => a.son).indexOf(caseChildCode) !== -1 || children.map(a => a.son).indexOf(caseChildH2) !== -1 || children.map(a => a.son).indexOf(caseChildH3) !== -1 || children.map(a => a.son).indexOf(caseChildH4) !== -1){
                let itemSelected;
                if(children.map(a => a.son).indexOf(caseChildCode) !== -1){itemSelected = caseChildCode.innerHTML};
                if(children.map(a => a.son).indexOf(caseChildP) !== -1){itemSelected = caseChildP.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH2) !== -1){itemSelected = caseChildH2.innerHTML};   
                if(children.map(a => a.son).indexOf(caseChildH3) !== -1){itemSelected = caseChildH3.innerHTML};    
                if(children.map(a => a.son).indexOf(caseChildH4) !== -1){itemSelected = caseChildH4.innerHTML};     

                textFixed = `${textFixed}<h4 style"color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:10px !important; margin-bottom:10px !important; ">${itemSelected}</h4>`

              }else{

                textFixed = mantainAllTagsCases(father,textFixed,childs[i])

              }
            }

          }

          newDiv.innerHTML = `${newDiv.innerHTML}${textFixed}`

          if(index !== 0){
            father.remove()
          }

        })

        for (const child of newDiv.children) {
          const clonedChild = child.cloneNode(true);
          fragmento.appendChild(clonedChild);
        }

        if(groupedElements[0].father.parentElement){
          groupedElements[0].father.replaceWith(fragmento)
        }

        formatErrors()
        onChangeInformation(containerInput)

      }
    }catch(er){
      console.log(er)
    }
  } 

  const createBold = (container) => {
    try{
      // const containerInput   = document.getElementById(`container-blog-input-${idClock}`);
      const startSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? range.startContainer.parentNode
        : range.startContainer.parentNode.tagName === "P"
          ? range.startContainer.parentNode
          : range.startContainer.parentNode.parentNode.tagName === "P"
            ? range.startContainer.parentNode.parentNode
            : range.startContainer.parentNode.parentNode.parentNode.tagName === "P"
              ? range.startContainer.parentNode.parentNode.parentNode 
              : range.startContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                ? range.startContainer.parentNode.parentNode.parentNode.parentNode
                : range.startContainer.parentNode
      const endSon = (bulUl || bulCode || bulBlockquote || bulOl)
        ? range.endContainer.parentNode
        : range.endContainer.parentNode.tagName === "P"
          ? range.endContainer.parentNode
          : range.endContainer.parentNode.parentNode.tagName === "P"
            ? range.endContainer.parentNode.parentNode
            : range.endContainer.parentNode.parentNode.parentNode.tagName === "P"
              ? range.endContainer.parentNode.parentNode.parentNode 
              : range.endContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                ? range.endContainer.parentNode.parentNode.parentNode.parentNode
                : range.endContainer.parentNode

      if(startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`){

        function findParent(element,type) {
          let parent = element.closest(type);
          let position = parent ? Array.from(parent.querySelectorAll('p')).indexOf(element) : null;
          return parent ? { parent, position } : { parent: null, position: null };
        }

        processExec("bold")
        // const groupedElements = agroupInformationSelectForTheUser(container)

        // groupedElements.forEach((item,index) => {
          
        //   const { father, children } = item;
        //   // console.log(father,children)

        //   if(['OL'].includes(father.tagName)){
        //     children.forEach(a => {
        //       let data = findParent(a.son,'li')
        //       if(!bulBold && a.son.children[0].tagName === 'B'){
        //         data.parent.style.cssText = `font-weight:bold;`
        //       }else{
        //         data.parent.style.cssText = ``
        //       }
        //     }) 
        //   }

        // })
      }

    }catch(er){
      console.log(er)
    }
  }

  const changeTextColor = () => {
    try {
      if(clockColor.current){clearTimeout(clockColor.current)}
      clockColor.current = setTimeout(() => {
        const startSon = (bulUl || bulCode || bulBlockquote || bulOl)
          ? range.startContainer.parentNode
          : range.startContainer.parentNode.tagName === "P"
            ? range.startContainer.parentNode
            : range.startContainer.parentNode.parentNode.tagName === "P"
              ? range.startContainer.parentNode.parentNode
              : range.startContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.startContainer.parentNode.parentNode.parentNode
                : range.startContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.startContainer.parentNode.parentNode.parentNode.parentNode
                  : range.startContainer.parentNode;
    
        const endSon = (bulUl || bulCode || bulBlockquote || bulOl)
          ? range.endContainer.parentNode
          : range.endContainer.parentNode.tagName === "P"
            ? range.endContainer.parentNode
            : range.endContainer.parentNode.parentNode.tagName === "P"
              ? range.endContainer.parentNode.parentNode
              : range.endContainer.parentNode.parentNode.parentNode.tagName === "P"
                ? range.endContainer.parentNode.parentNode.parentNode
                : range.endContainer.parentNode.parentNode.parentNode.parentNode.tagName === "P"
                  ? range.endContainer.parentNode.parentNode.parentNode.parentNode
                  : range.endContainer.parentNode;
    
        if (startSon.id !== "father-input-blog" && endSon.id !== "father-input-blog" && startSon.id !== `container-blog-input-${idClock}` && endSon.id !== `container-blog-input-${idClock}`) {

          console.log('paso por aqui')
          const colorPicker = document.getElementById(`color-picker-${idClock}`);

          if (colorPicker !== null) {
            document.execCommand('styleWithCSS', false, true);
            document.execCommand('foreColor', false, colorPicker.value);
            // processExec("foreColor", colorPicker.value)
          }
        }
      }, 100);
    } catch (er) {
      console.log(er);
    }
  };

  const swiftCase = (e , container) => {
    console.log('Step 1')
    console.log(container,e.target.options[e.target.selectedIndex].textContent )
     if(e.target.options[e.target.selectedIndex].textContent === 'normal'){
      createParraf()
     }
     if(e.target.options[e.target.selectedIndex].textContent === 'h2'){
      createH2(container)
     }
     if(e.target.options[e.target.selectedIndex].textContent === 'h3'){
      createH3(container)
     }
     if(e.target.options[e.target.selectedIndex].textContent === 'h4'){
      createH4(container)
     }
  }

  const elementResponse = (containerInput) => {
    try{
      const containerR = document.createElement("div");
      containerR.style.cssText =  `width:100%; height:auto; position:relative;`
      containerR.innerHTML = `${containerInput.innerHTML}`

      let filesAddEdit = {}

      let figureData = containerR.querySelectorAll("figure")

      for(let i = 0; i < figureData.length; i++){

        const eR = /@(.*?)@/;
        let firstCode = figureData[i]?.className
        const IdContainerImage = firstCode.match(eR) ? firstCode.match(eR)[0] : firstCode.match(eR)
        const IdExpand = figureData[i]?.children[0]?.id
        const IdImage = figureData[i]?.children[0]?.children[1]?.children[0]?.id
        const Id1 = figureData[i]?.children[0]?.children[0]?.children[0]?.children[0]?.id
        const Id2 = figureData[i]?.children[0]?.children[0]?.children[0]?.children[1]?.id
        const Id3 = figureData[i]?.children[0]?.children[0]?.children[0]?.children[2]?.id
        const IdSizeRange = figureData[i]?.children[0]?.children[0]?.children[0]?.children[3]?.id
        if([Id1,Id2,Id3,IdExpand,IdContainerImage,IdImage, IdSizeRange].some(e => e === undefined)){
          // newElement = newElement.replace(`${figureData[i].outerHTML}`,'')
        }else{
          let replaceBody = figureData[i]?.children[0]?.children[1]?.children[0]?.src
          if (replaceBody && replaceBody.startsWith(`blob`)) {

            filesAddEdit = {
              ...filesAddEdit,
              [IdContainerImage]: {
                data: filesAdd[IdContainerImage].data,
                replaceBody: figureData[i].children[0].children[1].children[0].src
              }
            }
          }
          
        }
      }

      // if(isEdit){
      //   Object.keys(filesAdd).map(e => {
      //     const { replaceBody, data } = filesAdd[e];
      //     const isBase64 = data.startsWith('data:image/') && data.includes('base64,');
      //     const isBlob = replaceBody.startsWith(`blob:${window.location.origin}`);

      //     if(isBase64 && isBlob){
      //       filesAddEdit[e] = filesAdd[e]
      //     }
      //   })
      // }

      return {
        body: filterElements(filterWidthsElements(containerR)),
        images: filesAddEdit
      }
    }catch(er){
      console.log(er)
    }
  }

  const replaceImagesResponse = (images,containerInput) => {
    try {
      const containerR = document.createElement("div");
      containerR.style.cssText =  `width:100%; height:auto;`
      containerR.innerHTML = containerInput.innerHTML

      const contChil = containerR.children

      if(contChil.length > 1 && (contChil[0].tagName === 'P' && (contChil[0].textContent === '' || contChil[0].textContent === ' '))){
        containerR.children[0].remove()
        containerInput.children[0].remove()
      }
    

      let containerResponse = filterElements(filterWidthsElements(containerR))

      for(let i = 0; i < Object.values(images)?.length; i++){
        containerResponse = containerResponse.replaceAll(Object.values(images)[i].replaceBody, Object.values(images)[i].data)
      } 

      return containerResponse
    }catch(er){
      console.log(er)
    }
  }

  const valueDefaultTransform = (data, containerInput) => {  
    try{
      if(data !== "" && data !== undefined ){
        // isEdit = true

        let newElement = data.replaceAll('<div id="replace-diivider" style="display:none;"></div>',`<div class="btn-delete-divider"></div>`)
                             .replaceAll("<div id='replace-diivider' style='display:none;'></div>",`<div class="btn-delete-divider"></div>`)
                             .replaceAll(`<div class="container-buton-buttons" style="display:none;"`,`<div class="container-buton-buttons"`)
        newElement = newElement.replaceAll(`<div style="display:none;" class="container-image-buttons"`,`<div class="container-image-buttons"`)
                               .replaceAll(`class="container-image-expand" contenteditable="false" style="width: 50%;`,`class="container-image-expand" contenteditable="false" style="width: ${(containerInput.clientWidth / 2) - 40}px;`)
                               .replaceAll(`class="container-image-expand-2" contenteditable="false" style="width: 100%;`,`class="container-image-expand-2" contenteditable="false" style="width: ${containerInput.clientWidth - 40}px;`)
                               .replaceAll(`<div id="container-see-start" style="position:absolute; top:0px; height:10px; width:100%; left:0px;"></div>`,"")
                               .replaceAll(`<div id="container-see-finish" style="position:absolute; bottom:0px; height:10px; width:100%; left:0px;"></div>`,"")

        //update codes
        const containerCodes = document.createElement("div");
        containerCodes.innerHTML = newElement

        let figureData = containerCodes.querySelectorAll("figure")
        let insertData = containerCodes.querySelectorAll(".container-insert")
        let dividerData = containerCodes.querySelectorAll(".btn-delete-divider")
        let buttonData = containerCodes.querySelectorAll(".container-buton-buttons")

        for(let i = 0; i < figureData.length; i++){

          const eR = /@(.*?)@/;
          let firstCode = figureData[i]?.className
          const IdContainerImage = firstCode.match(eR) ? firstCode.match(eR)[0] : firstCode.match(eR)
          const IdExpand = figureData[i]?.children[0]?.id
          const IdImage = figureData[i]?.children[0]?.children[1]?.children[0]?.id
          const Id1 = figureData[i]?.children[0]?.children[0]?.children[0]?.children[0]?.id
          const Id2 = figureData[i]?.children[0]?.children[0]?.children[0]?.children[1]?.id
          const Id3 = figureData[i]?.children[0]?.children[0]?.children[0]?.children[2]?.id
          let IdSizeRange = figureData[i]?.children[0]?.children[0]?.children[0]?.children[3]?.id
          if([Id1,Id2,Id3,IdExpand,IdContainerImage,IdImage].some(e => e === undefined)){
            newElement = newElement.replace(`${figureData[i].outerHTML}`,'')
          } else {
            if (IdSizeRange === undefined) {
              IdSizeRange = moment().format("YYYYMMDDhhmmssSSS-size-range");
              let btnDelete = figureData[i]?.children[0]?.children[0]?.children[0]?.children[2].outerHTML;
              newElement = newElement.replaceAll(btnDelete,`${btnDelete}<input id="${IdSizeRange}" class="input-range" title="Image Size" type='range' style="width: 100%; margin-top:10px; accent-color: #fe5621; margin-left: 24px;" ></input>`)
            }
            filesAdd = {
              ...filesAdd,
              [IdContainerImage]: {
                data: figureData[i].children[0].children[1].children[0].src,
                replaceBody: figureData[i].children[0].children[1].children[0].src
              }
            }
            setEventActionsImage(Id1,Id2,Id3,IdExpand,IdContainerImage,IdImage, IdSizeRange);
          }
          
          
        }

        for(let i = 0; i < insertData.length; i++){

          const eR = /@(.*?)@/;
          let firstCode = insertData[i].id
          const IdContainerImage = firstCode?.match(eR) ? firstCode?.match(eR)[0] : firstCode?.match(eR)
          const Id1 = insertData[i]?.children[0]?.children[0]?.children[0]?.children[0]?.id
          const IdSizeRangeVideo = insertData[i]?.children[0]?.children[0]?.children[0]?.children[1]?.id

          if([Id1,IdContainerImage].some(e => e === undefined)){
            newElement = newElement.replace(`${insertData[i].outerHTML}`,'')
          } else {
            if (IdSizeRangeVideo === undefined) {
              IdSizeRangeVideo = moment().format("YYYYMMDDhhmmssSSS-size-range-video");  
              let btnDelete = insertData[i]?.children[0]?.children[0]?.children[0]?.children[0].outerHTML;
              newElement = newElement.replaceAll(btnDelete,`${btnDelete}<input id="${IdSizeRangeVideo}" class="input-range" title="Video Resize" type='range' style="width: 75%; margin-top:10px; accent-color: #fe5621; margin-left: 24px;" ></input>`)
            }
            setEventActionsInsert(Id1,IdContainerImage,IdSizeRangeVideo);
          }
        }

        for(let i = 0; i < dividerData.length; i++){
          setEventToDeleteDivider(dividerData[i].parentElement.id)
        }

        for(let i = 0; i < buttonData.length; i++){
          let Id11 = buttonData[i].parentElement.children[0].children[0].id
          let Id22 = buttonData[i].children[0].children[0].id
          let Id33 = buttonData[i].children[0].children[1].id
          setEventsToButton(Id11,Id22,Id33);
        }

        containerInput.innerHTML = newElement
        onChangeInformation(containerInput)
      }
    }catch(er){
      console.log(er)
    }
    
  }

  const formattingWhenIsFromFroala = (containerInput) => {
    const parentDiv = containerInput.querySelector('div');

    // console.log('entro aqui:', parentDiv, containerInput)
    if (parentDiv !== null) {
      parentDiv.childNodes.forEach((originalElement, index) => {
        if (originalElement.nodeType === 1) {
          let newElement;
    
          if (originalElement.tagName.toLowerCase() === 'p') {
            let fontSize;
            let spanElement = originalElement.querySelector('span');
            
            if (spanElement) {
              fontSize = parseFloat(spanElement.style.fontSize);
            } else {
              fontSize = parseFloat(originalElement.style.fontSize);
            }
    
            fontSize = isNaN(fontSize) ? 0 : fontSize;
    
            if (fontSize > 14 && fontSize <= 18) {
              newElement = document.createElement('h4');
            } else if (fontSize > 18 && fontSize <= 24) {
              newElement = document.createElement('h3');
            } else if (fontSize > 24) {
              newElement = document.createElement('h2');
            } else {
              newElement = document.createElement('p');
            }
    
            let textContent = '';
            originalElement.childNodes.forEach((childNode) => {
              if (childNode.nodeType === 1) {
                if (childNode.tagName.toLowerCase() === 'strong' || childNode.tagName.toLowerCase() === 'span' || childNode.tagName.toLowerCase() === 'a') {
                  if (childNode.tagName.toLowerCase() === 'a') {
                    let newAElement = document.createElement('a');
                    newAElement.textContent = childNode.textContent;
                    newAElement.href = childNode.href;
                    textContent += newAElement.outerHTML;
                  } else {
                    textContent += childNode.textContent;
                  }
                } else if (childNode.tagName.toLowerCase() === 'u') {
                  textContent += childNode.textContent;
                }
              } else if (childNode.nodeType === 3) {
                textContent += childNode.textContent;
              }
            });
    
            // if (textContent.trim() !== '') {
            //   newElement.innerHTML = textContent;
            //   newElement.removeAttribute('style');
            //   newElement.id = `child-position-${index}`;
            //   containerInput.appendChild(newElement);
            // }
          } 
          // else {
          //   newElement = originalElement.cloneNode(true);
          //   newElement.removeAttribute('style');
          //   newElement.id = `child-position-${index}`;
          //   containerInput.appendChild(newElement);
          // }
        }
      });
    
      containerInput.removeChild(parentDiv);
    }
  };

  const resetInput = (containerInput) => {
    containerInput.innerHTML = '<p style="color: rgba(0,0,0,0.9); font-size: 14px; line-height: 16px; margin-top:20px !important; margin-bottom:20px !important;" data-placeholder="Write here"></p>'
    onChangeInformation(containerInput,true)
  }

  useEffect(() => {
    try {
      if (idClock !== '') {
        let containerInput = document.getElementById(`container-blog-input-${idClock}`);
        const buttonBold = document.getElementById(`button-bold-${idClock}`);
        const buttonItalic = document.getElementById(`button-italic-${idClock}`);
        const buttonList = document.getElementById(`button-list-${idClock}`);
        const buttonListN = document.getElementById(`button-listN-${idClock}`);
        const buttonBlockquote = document.getElementById(`button-blockquote-${idClock}`);
        const buttonCode = document.getElementById(`button-code-${idClock}`);
        const buttonDivider = document.getElementById(`button-divider-${idClock}`);
        const buttonLink = document.getElementById(`button-link-${idClock}`);
        const buttonInsert = document.getElementById(`button-insert-${idClock}`);
        const buttonInsertHtml = document.getElementById(`button-inserthtml-${idClock}`);
        const insertButton = document.getElementById(`insert-button-${idClock}`);
        const buttonImage = document.getElementById(`button-image-${idClock}`);
        const inputCase = document.getElementById(`input-case-${idClock}`);
        const colorPicker = document.getElementById(`color-picker-${idClock}`);
        arrayReset = [buttonBold, buttonItalic, buttonList, buttonListN, buttonBlockquote, buttonCode, buttonDivider, buttonLink, buttonInsert, insertButton, buttonImage, inputCase, colorPicker]
        console.log(containerInput)

        let eventosContainer = ["keyup", "keydown", "mousedown", "mouseup", "paste"];

        functionData({
          data: () => elementResponse(containerInput),
          functionReplaceImage: (images) => replaceImagesResponse(images, containerInput),
          functionValueDefault: (data) => valueDefaultTransform(data, containerInput),
          reset: () => resetInput(containerInput)
        })

        const searchContainerInputExist = () => {
          if (containerInput) {
            document.addEventListener("selectionchange", selectSituation);
            document.addEventListener("keydown", (e) => ctrlZFunction(e, containerInput));
            buttonBold.addEventListener("mousedown", () => createBold(containerInput));
            buttonItalic.addEventListener("mousedown", () => processExec("italic"));
            buttonDivider.addEventListener("mousedown", () => generateDivider(containerInput));
            buttonLink.addEventListener("mousedown", () => processModalA("Add link"));
            buttonList.addEventListener("mousedown", () => createUl(containerInput));
            buttonListN.addEventListener("mousedown", () => createOl(containerInput));
            buttonBlockquote.addEventListener("mousedown", () => createBlockquote(containerInput));
            buttonCode.addEventListener("mousedown", () => createCode(containerInput));
            inputCase.addEventListener("change", (e) => swiftCase(e, containerInput));
            colorPicker.addEventListener("input", () => changeTextColor(containerInput));
            buttonImage.addEventListener("change", () => generateImage(buttonImage, containerInput));
            insertButton.addEventListener("mousedown", () => generateButton(insertButton, containerInput));
            buttonInsert.addEventListener("mousedown", () => processModalInsert("Insert link video"))
            buttonInsertHtml.addEventListener("mousedown", () => { processModalInsert("Insert Embed"); setBulCaseInput(true) })

            for (let i in eventosContainer) {
              containerInput.addEventListener(eventosContainer[i], (e) => onKeyDownHandler(e, containerInput));
            }

          } else {
            setTimeout(() => {
              searchContainerInputExist();
            }, 100);
          }
        };

        searchContainerInputExist();

        return () => {
          document.removeEventListener("selectionchange", () => selectSituation());
          document.removeEventListener("keydown", (e) => ctrlZFunction(e, containerInput));
          buttonBold.removeEventListener("mousedown", () => createBold(containerInput));
          buttonItalic.removeEventListener("mousedown", () => processExec("italic"));
          buttonDivider.removeEventListener("mousedown", () => generateDivider(containerInput));
          buttonLink.removeEventListener("mousedown", () => processModalA("Add link"));
          buttonList.removeEventListener("mousedown", () => createUl(containerInput));
          buttonListN.removeEventListener("mousedown", () => createOl(containerInput));
          buttonBlockquote.removeEventListener("mousedown", () => createBlockquote(containerInput));
          buttonCode.removeEventListener("mousedown", () => createCode(containerInput));
          inputCase.removeEventListener("change", (e) => swiftCase(e, containerInput));
          colorPicker.removeEventListener("change", () => changeTextColor(containerInput));
          buttonImage.removeEventListener("change", () => generateImage(buttonImage, containerInput));
          insertButton.removeEventListener("mousedown", () => generateButton(insertButton, containerInput));
          buttonInsert.removeEventListener("mousedown", () => processModalInsert("Insert video"))
          buttonInsertHtml.removeEventListener("mousedown", () => { processModalInsert("Insert Embed"); setBulCaseInput(true) })

          for (let i in eventosContainer) {
            containerInput.removeEventListener(eventosContainer[i], (e) => onKeyDownHandler(e, containerInput));
          }
        };
      };
    } catch (er) {
      console.log(er)
    }

  }, [idClock]);

  return (
    <div className="container-blog-input" id={`father-input-blog-${idClock}`}>
      <div className="container-buttons">
        <div className="container-button">
          <select className="select-button" style={{ border: 'none', borderWidth: '0px' }} id={`input-case-${idClock}`}>
            <option>normal</option>
            <option>h2</option>
            <option>h3</option>
            <option>h4</option>
          </select>
        </div>
        <div className="container-button" id={`button-bold-${idClock}`} title="Bold font">
          <div className="button-bold"></div>
        </div>
        <div className="container-button" id={`button-italic-${idClock}`} title="Italics">
          <div className="button-italic"></div>
        </div>
        <div className="container-button" id={`button-list-${idClock}`} title="Unordered List">
          <div className="button-list"></div>
        </div>
        <div className="container-button" id={`button-listN-${idClock}`} title="Sorted List">
          <div className="button-listN"></div>
        </div>
        <div className="container-button" id={`button-blockquote-${idClock}`} title="Block Quote">
          <div className="button-blockquote"></div>
        </div>
        <div className="container-button" id={`button-code-${idClock}`} title="Code">
          <div className="button-code"></div>
        </div>
        <div className="container-button" id={`button-divider-${idClock}`} title="Divider">
          <div className="button-divider"></div>
        </div>
        <div className="container-button" id={`button-link-${idClock}`} title="Link">
          <div className="button-link"></div>
        </div>
        <div className="container-button" id={`button-insert-${idClock}`} title="Insert">
          <div className="button-insert"></div>
        </div>
        <div className={email === "barbara@hackinghr.io" ? "container-button" : "container-button-hidden"} id={`insert-button-${idClock}`} title="Insert Button">
          <div className="insert-button"></div>
        </div>
        <div className={email === "barbara@hackinghr.io" ? "container-button" : "container-button-hidden"} id={`button-inserthtml-${idClock}`}>
          <div className="button-inserthtml"></div>
        </div>
        <div className="container-button">
          <div className="button-image">
            <input type="file" id={`button-image-${idClock}`} style={{ marginLeft: '-3px', height: '35px', opacity: "0", width: "40px" }}></input>
          </div>
        </div>
        <div className="container-button" title="Text Color">
          <input type="color" className="button-color" id={`color-picker-${idClock}`} style={{ display: 'block' }} />
        </div>

      </div>
      <div
        className="container-html-editable"
        contentEditable="true"
        id={`container-blog-input-${idClock}`}
        translate="no"
        tabIndex="0"
        spellCheck="true"
        suppressContentEditableWarning={true}
        data-gramm="false"
      >
        <p style={{ color: "rgba(0,0,0,0.9)", fontSize: "14px", lineHeight: "16px", marginBottom: '20px', marginTop: '20px' }} data-placeholder="Write here"></p>
      </div>
      {textModal !== "" && (
        <div className={bulCaseInput ? "container-modals-2" : "container-modals"}>
          <div className="container-distribution">
            <div className="container-header">{textModal}</div>
            <div className="container-input">
              {bulCaseInput ? (
                <CustomInput
                  style={{ height: "10px" }}
                  autoFocus="autofocus"
                  multiple={true}
                  onChange={(e) => setDataInputModal(e)}
                />
              ) : <CustomInput
                style={{ height: "10px" }}
                autoFocus="autofocus"
                onChange={(e) => setDataInputModal(e)}
              />}
            </div>
            <div className="container-buttons-modal">
              <CustomButton
                text="cancel"
                size="sm"
                onClick={() => setTextModal("")}
              />
              <CustomButton
                text="ok"
                size="sm"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  if (textModal === "Add link") {
                    createLink();
                  }
                  if (textModal === "Insert link video") {
                    createInsert();
                  }
                  if (textModal === "Insert Embed") {
                    createInsertHtml();
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div className="container-modals-image" id="modal-container-image">
        <div className="container-distribution">
          <div className="container-header">
            <h2>Edit</h2>
            <svg style={{ cursor: 'pointer' }} onClick={() => cancelModalImage()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false">
              <path d="M14 3.41L9.41 8 14 12.59 12.59 14 8 9.41 3.41 14 2 12.59 6.59 8 2 3.41 3.41 2 8 6.59 12.59 2z"></path>
            </svg>
          </div>
          <div className="container-input">
            <h3>Add link</h3>
            <p>It will be possible to click on the image and it will lead to the link.</p>
            <input id="link-text-related"></input>
            <h3>Add alternative text</h3>
            <p>The text you add here is intended for visually impaired users only. It will not be displayed in the article.</p>
            <input id="alt-text-related"></input>
            <input style={{ position: 'absolute', opacity: "0", left: '1000px' }} id="code-text-related"></input>
            <img id="image-modal" alt="il-modal" />
            <div></div>
          </div>
          <div className="container-buttons-modal">
            <CustomButton
              text="cancel"
              size="sm"
              onClick={() => cancelModalImage()}
            />
            <CustomButton
              text="ok"
              size="sm"
              style={{ marginLeft: "10px" }}
              onClick={() => addChangesImage()}
            />
          </div>
        </div>
      </div>
      <div className="container-modals-button" id={`modal-container-button-${idClock}`}>
        <div className="container-distribution">
          <div className="container-header">
            <h2>Edit</h2>
            <svg style={{ cursor: 'pointer' }} onClick={() => cancelModalButton()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" width="16" height="16" focusable="false">
              <path d="M14 3.41L9.41 8 14 12.59 12.59 14 8 9.41 3.41 14 2 12.59 6.59 8 2 3.41 3.41 2 8 6.59 12.59 2z"></path>
            </svg>
          </div>
          <div className="container-input">
            <h3>Text Button</h3>
            <input id={`text-button-${idClock}`}></input>
            <div style={{ display: 'flex', gap: '10px', position: 'relative', background: 'transparent', maxHeight: '80px' }}>
              <h3>Color Button:</h3>
              <input id={`color-button-${idClock}`} type="color" style={{ maxWidth: '50px' }} defaultValue={'#fe5621'}></input>
              <h3>Text Color Button:</h3>
              <input id={`color-text-button-${idClock}`} type="color" style={{ maxWidth: '50px' }}></input>
            </div>
            <h3>Type Of Action</h3>
            <div style={{position:'relative',display:'flex',flexDirection:'row',justifyContent:'center',background:'none',height:'40px',width:'100%'}}>
              <fieldset id={`fieldsetradios-${idClock}`} onChange={(e) => {setSelectionOfButton(e.target.value)}} style={{position:'relative',display:'flex',flexDirection:'row',justifyContent:'center',background:'none',height:'40px',width:'100%'}}>
                <div style={{display:'flex',flexDirection:'row',width:'100px',background:'none',justifyContent:'center',alignItems:'center',position:'relative',left:'auto'}}>
                  <input value="linkredirect" name="typeData" type="radio" style={{marginBottom:'0px',height:'20px'}}/>
                  <label for="linkredirect" style={{color:'white',zIndex:'5',fontSize:'15px'}}>Redirect</label>
                </div>
                <div style={{display:'flex',flexDirection:'row',width:'100px',background:'none',justifyContent:'center',alignItems:'center',position:'relative',left:'auto'}}>
                  <input value="resource" name="typeData" type="radio" style={{marginBottom:'0px',height:'20px'}}/>
                  <label for="resource" style={{color:'white',zIndex:'5',fontSize:'15px'}}>Resource</label>
                </div>
                <div style={{display:'flex',flexDirection:'row',width:'100px',background:'none',justifyContent:'center',alignItems:'center',position:'relative',left:'auto'}}>
                  <input value="hubspot" name="typeData" type="radio" style={{marginBottom:'0px',height:'20px'}}/>
                  <label for="hubspot" style={{color:'white',zIndex:'5',fontSize:'15px'}}>HubSpot</label>
                </div>
              </fieldset>
            </div>
            
            <div className="container-modal-input-button" style={selectionOfButton === "linkredirect" ? {opacity: '1', position:'relative',left:'0px'} : {opacity: '0', position:'absolute',left:'-100000000000px'}}>
              <h3>Link to Redirect</h3>
              <input id={`link-to-redirect-${idClock}`}></input>
            </div>
            <div className="container-modal-input-button" style={selectionOfButton === "hubspot" ? {opacity: '1', position:'relative',left:'0px'} : {opacity: '0', position:'absolute',left:'-100000000000px'}}>
              <h3>FormId</h3>
              <input id={`form-id-${idClock}`}></input>
            </div>
            <div className="container-modal-input-button" style={selectionOfButton === "resource" ? {opacity: '1', position:'relative',left:'0px'} : {opacity: '0', position:'absolute',left:'-100000000000px'}}>
              <h3>Select Resource</h3>
              <select style={{ border: 'none', borderWidth: '0px', zIndex: 100 }} id={`resource-modal-${idClock}`} >
                {resources.map((resource, index) => {
                  return (<option value={resource.id}>{resource.name}</option>)
                })}
              </select>
            </div>
            <div></div>
            <input style={{ position: 'absolute', opacity: "0", left: '1000px' }} id={`code-text-related-btn-${idClock}`}></input>
          </div>
          <div className="container-buttons-modal">
            <CustomButton
              text="cancel"
              size="sm"
              onClick={() => cancelModalButton()}
            />
            <CustomButton
              text="ok"
              size="sm"
              style={{ marginLeft: "10px" }}
              onClick={() => addChangesButton()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputBlog;